<template>
  <div class="home overflow-hidden">
    <Header />
    <!-- <Test /> -->
    <section class="content py-5" style="min-height: 100vh">
      <!-- <VueSlickCarousel v-bind="contentCarouselSettings">
        <div v-for="(carouselData, idx) in homeData.carousel" :key="idx" class="hero d-flex align-items-center">
          <img
            class="d-md-block d-none w-100"
            style="cursor: pointer"
            id="show-btn"
            :src="carouselData.main"
            alt=""
          />
          <! -- @click="openYtModal('_pwGRGdpZcI')" -- >
          <img
            class="d-md-none d-block w-100"
            style="cursor: pointer"
            id="show-btn"
            :src="carouselData.mobile"
            alt=""
          />
        </div>
      </VueSlickCarousel> -->

      <!-- preload first images of the main carousel -->
      <!-- <img v-if="homeData.carousel" class="d-none" height="0" width="0" rel="preload" :src="homeData.carousel[0].mobile" alt="">
      <img v-if="homeData.carousel" class="d-none" height="0" width="0" rel="preload" :src="homeData.carousel[0].main" alt="">

      <b-carousel class="d-none d-md-block mt-3" style="cursor: pointer;" :interval="3000">
        <div @click="() => homeCarouselClick(carouselData.type, carouselData.action)" v-for="(carouselData, idx) in homeData.carousel" :key="idx">
          <b-carousel-slide rel="preload" :img-src="carouselData.main"></b-carousel-slide>
        </div>
      </b-carousel>
      <b-carousel class="d-md-none" :interval="3000">
        <div @click="() => homeCarouselClick(carouselData.type, carouselData.action)" v-for="(carouselData, idx) in homeData.carousel" :key="idx">
          <b-carousel-slide rel="preload" :img-src="carouselData.mobile"></b-carousel-slide>
        </div>
      </b-carousel> -->

      <!-- <section class="home-banner">
        <VueSlickCarousel style="cursor: pointer;" v-bind="contentCarouselSettings">
          <template
            v-for="(carouselData, idx) in homeData.carousel"
          >
            <picture
              :key="idx"
              @click="() => homeCarouselClick(carouselData.type, carouselData.action)"
            >
              <source rel="preload" width="100%" height="100%" media="(max-width: 576px)" :srcset="carouselData.mobile" />
              <img rel="preload" width="100%" height="100%" :src="carouselData.main" :alt="`Banner image ${idx+1}`" />
            </picture>
          </template>
        </VueSlickCarousel>
      </section> -->

      <!-- Banner carousel version 4 -->
      <div class="home-banner2">
        <!-- fallback image to display
          while the carousel is not loaded yet -->
        <picture class="fallback-image">
          <source class="w-100" media="(min-width: 576px)" srcset="https://images.avishkaar.cc/banner_carousel/desktop/home_page_banner_desktop_(resize).webp">
          <img class="w-100" height="100%" width="100%" src="https://images.avishkaar.cc/banner_carousel/mobile/home_page_banner_mobile_(resize).webp" alt="Banner">
        </picture>
        <b-carousel class="desktop-carousel" style="cursor: pointer;" :interval="9000" controls indicators>
          <div @click="() => homeCarouselClick(carouselData.type, carouselData.action)" v-for="(carouselData, idx) in homeData.carousel" :key="idx">
            <!-- <b-carousel-slide rel="preload" :img-src="carouselData.main"></b-carousel-slide> -->
            <div :class="`carousel-item ${idx == 0 ? 'active' : ''}`">
              <picture>
                <source class="w-100" media="(min-width: 576px)" :srcset="carouselData.main" loading="lazy">
                <img class="w-100" :src="carouselData.mobile" :alt="`Banner ${idx+1}`" loading="lazy">
              </picture>
            </div>
          </div>
        </b-carousel>
        <!-- <b-carousel class="d-md-none mobile-carousel" :interval="3000" indicators>
          <div @click="() => homeCarouselClick(carouselData.type, carouselData.action)" v-for="(carouselData, idx) in homeData.carousel" :key="idx">
            <b-carousel-slide rel="preload" :img-src="carouselData.mobile"></b-carousel-slide>
          </div>
        </b-carousel> -->
      </div>

      <!-- request a call section -->
      <div class="req-call">
        <div class="d-flex container">
          <div>Want to know how Avishkaar can help your child gain the edge?</div>
          <button class="ab-btn" @click="showRequestCall('Request a call!')">Request a call</button>
        </div>
        <svg class="req-call-caller" width="118" height="116" viewBox="0 0 118 116" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M58.9858 89.0629C48.3377 89.0629 37.5197 82.6639 31.2061 74.1944C0.915651 74.1944 0 118 0 118H117.964C117.964 118 120.342 74 86.2782 74C79.972 82.5742 69.634 89.0629 58.9858 89.0629Z" fill="#18689A"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M84 37.6205C84 50.1125 72.8089 74 58.9927 74C45.1984 74 34 50.1051 34 37.6205C34 25.1359 45.1911 15 58.9927 15C72.8089 15.0074 84 25.1433 84 37.6205Z" fill="#18689A"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M95.9256 26.4059C95.9256 24.0829 92.6536 22.2083 88.5933 22.1936V17.4079C88.5933 16.6948 88.8685 0 59.0335 0C29.2133 0 29.4885 16.6948 29.4885 17.4079V22.3627C29.4141 22.3627 29.3546 22.3406 29.2877 22.3406C25.2497 22.3406 22 24.1858 22 26.472V46.7175C22 48.9891 25.2572 50.8416 29.2877 50.8416C33.3183 50.8416 36.5903 48.9891 36.5903 46.7175V26.472C36.5903 26.1559 36.3895 25.8692 36.2705 25.5752V20.0544C36.2705 19.5471 34.1288 6.94698 59.0335 6.94698C83.9455 6.94698 81.3577 19.5471 81.3577 20.0544V25.8692C81.313 26.053 81.1717 26.2147 81.1717 26.4059V47.1145C81.1717 49.4449 84.4661 51.3342 88.5487 51.3342C88.6379 51.3342 88.7049 51.3047 88.7941 51.3047V58.8692H81.4766V66H96L95.9256 26.4059Z" fill="#18689A"/>
        </svg>
      </div>

      <div class="py-5">
        <h2 class="pb-5">The Three Step Mantra to <br />Changing the World</h2>
        <!-- <img class="col-md-7 col-12" src="" alt="" width="100%"> -->
        <!-- <div class="d-md-block d-none">
          <b-img-lazy
            v-bind="mainProps"
            class="col-md-7 col-12"
            :src="'https://images.avishkaar.cc/workflow/vue/hp/step.png'"
            alt="Image 1"
          ></b-img-lazy>
        </div>
        <div class="d-md-none d-block">
          <b-img-lazy
            v-bind="mainProps"
            class="col-md-7 col-12"
            :src="'https://images.avishkaar.cc/workflow/vue/hp/stepM.webp'"
            alt="Image 1"
          ></b-img-lazy>
        </div> -->
        <picture>
          <source
            media="(min-width: 576px)"
            srcset="https://images.avishkaar.cc/workflow/vue/hp/step.png"
            width="56%"
            height="100%"
            loading="lazy"
          >
          <img
          src="https://images.avishkaar.cc/workflow/vue/hp/stepM.webp"
          alt="Share, Win, Innovate"
          width="90%"
          height="100%"
          loading="lazy"
        >
        </picture>
      </div>

      <div>
        <div class="pb-5 pt-md-5">
          <svg
            class="col-3"
            width="88"
            height="88"
            viewBox="0 0 88 88"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M44.0001 0.666016C20.0801 0.666016 0.666748 20.0794 0.666748 43.9994C0.666748 67.9194 20.0801 87.3327 44.0001 87.3327C67.9201 87.3327 87.3334 67.9194 87.3334 43.9994C87.3334 20.0794 67.9201 0.666016 44.0001 0.666016ZM63.6734 60.6827L60.6834 63.6727C60.2825 64.0744 59.8063 64.3931 59.2821 64.6106C58.7579 64.828 58.1959 64.9399 57.6284 64.9399C57.0609 64.9399 56.4989 64.828 55.9747 64.6106C55.4505 64.3931 54.9743 64.0744 54.5734 63.6727L41.3568 50.456C36.0701 52.3194 29.9167 51.1927 25.6701 46.946C23.3892 44.6538 21.9084 41.687 21.4478 38.4863C20.9872 35.2856 21.5714 32.0217 23.1134 29.1794L33.2967 39.3627L39.4067 33.2527L29.1801 23.0694C34.9001 19.9927 42.1367 20.816 46.9468 25.626C51.1934 29.8727 52.3201 36.026 50.4567 41.3127L63.6734 54.5294C65.3634 56.2194 65.3634 58.9927 63.6734 60.6827Z"
              fill="#F36F2E"
            />
          </svg>
          <h2 class="pt-md-2 mb-0" style="color: rgb(243, 111, 46) !important">
            Innovate
          </h2>
          <hr
            class="mt-1"
            style="
              width: 7%;
              margin-left: auto; margin-right: auto;
              background: #f36f2e;
              padding: 2px;
              border-radius: 3.5px;
            "
          />
          <!-- phone -->
          <!-- <h2 class="mb-3 d-block d-md-none col-md-8 mx-auto pt-4">
            Innovate with Avishkaar Kits & <span class="d-none d-md-inline-block"><br />
            </span>earn Inter-Disciplinary <br />
            Problem-Solving
          </h2> -->
          <!-- desktop -->
          <h2 class="mb-3 col-md-9 mx-auto pt-4">
            Innovate with Avishkaar Kits & earn Inter-Disciplinary <br />
            Problem-Solving
          </h2>
          <p class="mb-2 px-5">
            Develop skills that will be needed for <br /> 85% of jobs in the future
          </p>
        </div>
        <div class="mt-5 skills_card">
          <b-card no-body>
            <b-tabs align="center" v-if="homeData.dataBySkillCode">
              <b-tab
                :style="'background: #' + skillProject[0].skill_color"
                @click="skillHeadBG(skillProject[0].skill_color)"
                v-for="(skillProject, index) in homeData.dataBySkillCode"
                :key="index"
                class="pb-5"
              >
                <template #title>
                  <div
                    class="subTabIcon"
                    :style="'background: #' + skillProject[0].skill_color"
                  >
                    <div>
                      <img
                        :src="skillProject[0].icon_link"
                        alt=""
                        class="skill_image"
                      />
                    </div>
                    <p class="m-0 pt-2 text-white">
                      {{ skillProject[0].skill_name }}
                    </p>
                  </div>
                </template>
                <div class="px-md-5 px-0 pt-5 innovate-carousel">
                  <VueSlickCarousel v-bind="skillsSettings" class="px-2">
                    <div
                      v-for="(
                        skillProjectEle, skillProjectEleKey
                      ) in skillProject"
                      :key="skillProjectEleKey"
                    >
                      <CarouselCard
                        :type="'projectCard'"
                        :name="skillProjectEle.project_name"
                        :age="skillProjectEle.age"
                        :description="skillProjectEle.description"
                        :skillName="skillProjectEle.skill_name"
                        :projectImage="skillProjectEle.project_image"
                        :skillColor="skillProjectEle.skill_color"
                        :skillImage="skillProjectEle.icon_link"
                        :productUri="skillProjectEle.product_uri"
                        :redirectLink="skillProjectEle.redirect_link"
                      />
                    </div>
                  </VueSlickCarousel>
                </div>
              </b-tab>

              <!--<b-tab @click="skillHeadBG(2)">
                  <template #title>
                      <div>
                        <svg width="64" height="48" viewBox="0 0 64 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M25.503 24.5297C26.128 25.1156 27.141 25.1156 27.766 24.5297L28.897 23.4694C29.522 22.8834 29.522 21.9338 28.897 21.3478L25.325 18L28.896 14.6512C29.521 14.0653 29.521 13.1156 28.896 12.5297L27.765 11.4694C27.14 10.8834 26.127 10.8834 25.502 11.4694L19.668 16.9387C19.043 17.5247 19.043 18.4744 19.668 19.0603L25.503 24.5297ZM35.104 23.4703L36.235 24.5306C36.86 25.1166 37.873 25.1166 38.498 24.5306L44.332 19.0613C44.957 18.4753 44.957 17.5256 44.332 16.9397L38.498 11.4703C37.873 10.8844 36.86 10.8844 36.235 11.4703L35.104 12.5306C34.479 13.1166 34.479 14.0662 35.104 14.6522L38.675 18L35.104 21.3488C34.479 21.9347 34.479 22.8844 35.104 23.4703ZM62.4 39H38.154C38.08 40.8572 36.683 42 34.88 42H28.8C26.931 42 25.498 40.3622 25.523 39H1.6C0.72 39 0 39.675 0 40.5V42C0 45.3 2.88 48 6.4 48H57.6C61.12 48 64 45.3 64 42V40.5C64 39.675 63.28 39 62.4 39ZM57.6 4.5C57.6 2.025 55.44 0 52.8 0H11.2C8.56 0 6.4 2.025 6.4 4.5V36H57.6V4.5ZM51.2 30H12.8V6H51.2V30Z" fill="white"/>
                        </svg>
                    </div>
                    <p class="m-0 pt-2 text-white">App Dev</p>
                  </template>
                  <div class="px-5 pt-5">
                    <VueSlickCarousel v-bind="skillsSettings" class="px-2">
                      <CarouselCard :type="'projectCard'" :name="'test'" :age="'10'" :description="'test'" :skillName="'Robotics'" :projectImage="'https://images.avishkaar.cc/student-stories-shop-home/test.svg'" :skillColor="'EB621F'" :skillImage="'https://images.avishkaar.cc/skills-icons/robotics.svg'" :productUri="'test'"/>
                      <CarouselCard :type="'projectCard'" :name="'test'" :age="'10'" :description="'test'" :skillName="'Robotics'" :projectImage="'https://images.avishkaar.cc/student-stories-shop-home/test.svg'" :skillColor="'EB621F'" :skillImage="'https://images.avishkaar.cc/skills-icons/robotics.svg'" :productUri="'test'"/>
                      <CarouselCard :type="'projectCard'" :name="'test'" :age="'10'" :description="'test'" :skillName="'Robotics'" :projectImage="'https://images.avishkaar.cc/student-stories-shop-home/test.svg'" :skillColor="'EB621F'" :skillImage="'https://images.avishkaar.cc/skills-icons/robotics.svg'" :productUri="'test'"/>
                      <CarouselCard :type="'projectCard'" :name="'test'" :age="'10'" :description="'test'" :skillName="'Robotics'" :projectImage="'https://images.avishkaar.cc/student-stories-shop-home/test.svg'" :skillColor="'EB621F'" :skillImage="'https://images.avishkaar.cc/skills-icons/robotics.svg'" :productUri="'test'"/>
                    </VueSlickCarousel>
                  </div>
                </b-tab>

                <b-tab @click="skillHeadBG(3)">
                  <template #title>
                    <div>
                      <svg width="48" height="48" viewBox="0 0 44 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M36.108 6.57143L30.8101 11.8505V12.2448L36.108 17.5238H44V21.9048H34.3054L30.8101 18.4219V24.0952H28.6117C27.4457 24.0952 26.3274 23.6337 25.5028 22.8121C24.6783 21.9905 24.2151 20.8762 24.2151 19.7143V14.2381H17.3123C17.1145 15.0486 16.7847 15.8152 16.3451 16.5381L29.0074 39.4286H39.6034C40.7694 39.4286 41.8877 39.8901 42.7122 40.7117C43.5368 41.5333 44 42.6476 44 43.8095V46H0.0335133V43.8095C0.0335133 42.6476 0.49673 41.5333 1.32126 40.7117C2.14579 39.8901 3.2641 39.4286 4.43016 39.4286H18.9611L8.65094 20.8095C6.7259 20.7771 4.86456 20.1169 3.35189 18.9301C1.83921 17.7432 0.758547 16.0951 0.275329 14.2381C-0.011767 13.122 -0.0751106 11.9603 0.0889239 10.8198C0.252958 9.67921 0.64115 8.58208 1.23127 7.5912C1.8214 6.60032 2.60187 5.73515 3.528 5.04522C4.45413 4.35528 5.50773 3.85414 6.62849 3.57048C11.3109 2.36571 16.1033 5.16952 17.3123 9.85714H24.2151V4.38095C24.2151 3.21905 24.6783 2.10474 25.5028 1.28315C26.3274 0.461563 27.4457 0 28.6117 0H30.8101V5.67333L34.3054 2.19048H44V6.57143H36.108ZM8.82681 7.66667C7.66075 7.66667 6.54244 8.12823 5.71791 8.94982C4.89338 9.77141 4.43016 10.8857 4.43016 12.0476C4.43016 13.2095 4.89338 14.3238 5.71791 15.1454C6.54244 15.967 7.66075 16.4286 8.82681 16.4286C9.99287 16.4286 11.1112 15.967 11.9357 15.1454C12.7602 14.3238 13.2235 13.2095 13.2235 12.0476C13.2235 10.8857 12.7602 9.77141 11.9357 8.94982C11.1112 8.12823 9.99287 7.66667 8.82681 7.66667Z" fill="white"/>
                      </svg>
                    </div>
                    <p class="m-0 pt-2 text-white">Robotics</p>
                  </template>
                  <div class="px-5 pt-5">
                    <VueSlickCarousel v-bind="skillsSettings" class="px-2">
                      <CarouselCard :type="'projectCard'" :name="'test'" :age="'10'" :description="'test'" :skillName="'Robotics'" :projectImage="'https://images.avishkaar.cc/student-stories-shop-home/test.svg'" :skillColor="'EB621F'" :skillImage="'https://images.avishkaar.cc/skills-icons/robotics.svg'" :productUri="'test'"/>
                      <CarouselCard :type="'projectCard'" :name="'test'" :age="'10'" :description="'test'" :skillName="'Robotics'" :projectImage="'https://images.avishkaar.cc/student-stories-shop-home/test.svg'" :skillColor="'EB621F'" :skillImage="'https://images.avishkaar.cc/skills-icons/robotics.svg'" :productUri="'test'"/>
                      <CarouselCard :type="'projectCard'" :name="'test'" :age="'10'" :description="'test'" :skillName="'Robotics'" :projectImage="'https://images.avishkaar.cc/student-stories-shop-home/test.svg'" :skillColor="'EB621F'" :skillImage="'https://images.avishkaar.cc/skills-icons/robotics.svg'" :productUri="'test'"/>
                      <CarouselCard :type="'projectCard'" :name="'test'" :age="'10'" :description="'test'" :skillName="'Robotics'" :projectImage="'https://images.avishkaar.cc/student-stories-shop-home/test.svg'" :skillColor="'EB621F'" :skillImage="'https://images.avishkaar.cc/skills-icons/robotics.svg'" :productUri="'test'"/>
                    </VueSlickCarousel>
                  </div>
                </b-tab>

                <b-tab @click="skillHeadBG(4)">
                  <template #title>
                    <div>
                      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M45 28.5H39V22.5H36V36H12V12H25.5V9H19.5V3H16.5V9H12C11.2046 9.00079 10.442 9.31712 9.87956 9.87956C9.31712 10.442 9.00079 11.2046 9 12V16.5H3V19.5H9V28.5H3V31.5H9V36C9.00079 36.7954 9.31712 37.558 9.87956 38.1204C10.442 38.6829 11.2046 38.9992 12 39H16.5V45H19.5V39H28.5V45H31.5V39H36C36.7953 38.9988 37.5577 38.6824 38.12 38.12C38.6824 37.5577 38.9988 36.7953 39 36V31.5H45V28.5Z" fill="white"/>
                      <path d="M31.5 31.5H16.5V16.5H31.5V31.5ZM19.5 28.5H28.5V19.5H19.5V28.5Z" fill="white"/>
                      <path d="M46.5 19.5H43.5C43.4952 15.5232 41.9134 11.7107 39.1013 8.89866C36.2893 6.08665 32.4768 4.50476 28.5 4.5V1.5C33.2723 1.50516 37.8477 3.40324 41.2222 6.77778C44.5968 10.1523 46.4948 14.7277 46.5 19.5Z" fill="white"/>
                      <path d="M39 19.5H36C35.9976 17.5116 35.2067 15.6053 33.8007 14.1993C32.3947 12.7933 30.4884 12.0024 28.5 12V9C31.2838 9.00318 33.9527 10.1104 35.9211 12.0789C37.8896 14.0473 38.9968 16.7162 39 19.5Z" fill="white"/>
                      </svg>
                    </div>
                    <p class="m-0 pt-2 text-white">IoT</p>
                  </template>
                  <div class="px-5 pt-5">
                    <VueSlickCarousel v-bind="skillsSettings" class="px-2">
                      <CarouselCard :type="'projectCard'" :name="'test'" :age="'10'" :description="'test'" :skillName="'Robotics'" :projectImage="'https://images.avishkaar.cc/student-stories-shop-home/test.svg'" :skillColor="'EB621F'" :skillImage="'https://images.avishkaar.cc/skills-icons/robotics.svg'" :productUri="'test'"/>
                      <CarouselCard :type="'projectCard'" :name="'test'" :age="'10'" :description="'test'" :skillName="'Robotics'" :projectImage="'https://images.avishkaar.cc/student-stories-shop-home/test.svg'" :skillColor="'EB621F'" :skillImage="'https://images.avishkaar.cc/skills-icons/robotics.svg'" :productUri="'test'"/>
                      <CarouselCard :type="'projectCard'" :name="'test'" :age="'10'" :description="'test'" :skillName="'Robotics'" :projectImage="'https://images.avishkaar.cc/student-stories-shop-home/test.svg'" :skillColor="'EB621F'" :skillImage="'https://images.avishkaar.cc/skills-icons/robotics.svg'" :productUri="'test'"/>
                      <CarouselCard :type="'projectCard'" :name="'test'" :age="'10'" :description="'test'" :skillName="'Robotics'" :projectImage="'https://images.avishkaar.cc/student-stories-shop-home/test.svg'" :skillColor="'EB621F'" :skillImage="'https://images.avishkaar.cc/skills-icons/robotics.svg'" :productUri="'test'"/>
                    </VueSlickCarousel>
                  </div>
                </b-tab>-->
            </b-tabs>
          </b-card>
        </div>
      </div>
      <div
        class="py-5 d-flex flex-wrap align-items-center"
        style="background: #f8f8f8"
      >
        <div
          class="d-flex justify-content-center flex-wrap mt-4 mx-auto pb-5 px-md-5"
        >
          <div class="col-md-9 col-12 pb-4">
            <h2>
              Answer a Few Questions and we’ll Help you Understand your Child’s
              Innovator Profile
            </h2>
            <p class="col-md-7 col-12 mx-auto">
              And recommend the most suitable product <span class="d-md-none"><br /></span>and learning experience
              for your kid based on their interest and skill
            </p>
          </div>
          <button
            id="show-btn"
            @click="showModal"
            class="ab-btn col-md-4 col-11 mx-4 my-md-0 my-2"
          >
            Take the Quiz
          </button>
          <router-link
            to="/shop"
            class="ab-btn-border col-md-4 col-11 mx-2 my-md-0 my-2"
            style="color: #f36f2e"
            >View All Products</router-link
          >
        </div>
        <div
          class="col-md-10 col-11 py-5 mx-auto px-1 bg-white"
          style="box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.07)"
        >
          <h2 class="mb-4 col-md-9 col-12 mx-auto text-dark">
            <!-- style="font-size: 24px" -->
            <strong
              >The Complete Learning <span class="d-md-none"><br /></span> Experience with Avishkaar <span class="d-md-none"><br /></span> Online
              Courses</strong
            >
          </h2>
          <div class="d-flex flex-wrap">
            <div class="col-lg-3 col-md-6 col-12 d-flex flex-wrap h-100">
              <svg
                class="col-md-6 mx-auto col-4 my-auto"
                width="116"
                height="116"
                viewBox="0 0 116 116"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M58 116C90.0325 116 116 90.0325 116 58C116 25.9675 90.0325 0 58 0C25.9675 0 0 25.9675 0 58C0 90.0325 25.9675 116 58 116Z"
                  fill="#FCAC31"
                />
                <path
                  d="M89.1089 27.8462H28.7764C25.8715 27.8462 23.5625 30.1552 23.5625 33.0601V82.0709C23.5625 84.9758 25.946 87.2848 28.7764 87.2848H89.0344C91.9393 87.2848 94.2483 84.9758 94.2483 82.0709V33.0601C94.3228 30.1552 91.9393 27.8462 89.1089 27.8462Z"
                  fill="#365E7D"
                />
                <path
                  d="M49.7816 34.86C49.7816 33.6683 48.8133 32.6255 47.547 32.6255C46.2808 32.6255 45.3125 33.5938 45.3125 34.86C45.3125 36.0518 46.2808 37.0946 47.547 37.0946C48.7388 37.0946 49.7816 36.1263 49.7816 34.86Z"
                  fill="#9BC157"
                />
                <path
                  d="M35.2816 34.86C35.2816 33.6683 34.3133 32.6255 33.047 32.6255C31.7808 32.6255 30.8125 33.5938 30.8125 34.86C30.8125 36.0518 31.7808 37.0946 33.047 37.0946C34.2388 37.0946 35.2816 36.1263 35.2816 34.86Z"
                  fill="#E63638"
                />
                <path
                  d="M42.5316 34.86C42.5316 33.6683 41.5633 32.6255 40.297 32.6255C39.0308 32.6255 38.0625 33.5938 38.0625 34.86C38.0625 36.0518 39.0308 37.0946 40.297 37.0946C41.4888 37.0946 42.5316 36.1263 42.5316 34.86Z"
                  fill="#FCAC31"
                />
                <path
                  d="M87.3958 77.1068C87.6192 77.1068 87.7682 76.9578 87.7682 76.7344H87.6937V39.6411H30.1172V76.7344C30.1172 76.9578 30.2662 77.1068 30.4896 77.1068H87.3958Z"
                  fill="white"
                />
                <path
                  d="M46.8761 58.7318C50.0436 58.7318 52.6114 56.1641 52.6114 52.9965C52.6114 49.829 50.0436 47.2612 46.8761 47.2612C43.7085 47.2612 41.1407 49.829 41.1407 52.9965C41.1407 56.1641 43.7085 58.7318 46.8761 58.7318Z"
                  fill="#E63638"
                />
                <path
                  d="M39.0551 72.1396C41.5131 72.661 44.1946 72.959 46.876 72.959C49.6319 72.959 52.2389 72.661 54.6969 72.1396C55.3672 71.9907 55.7397 71.3948 55.6652 70.7244L55.0693 65.734C54.6969 62.6801 52.0899 60.3711 48.9616 60.3711H44.6415C41.5131 60.3711 38.9062 62.6801 38.5337 65.734L37.9379 70.7244C37.9379 71.3203 38.3848 71.9907 39.0551 72.1396Z"
                  fill="#E63638"
                />
                <path
                  d="M69.9664 69.4583C75.4037 69.4583 79.7983 65.0638 79.7983 59.6264C79.7983 54.189 75.4037 49.7944 69.9664 49.7944C64.529 49.7944 60.1344 54.189 60.1344 59.6264C60.1344 65.0638 64.529 69.4583 69.9664 69.4583ZM67.0615 56.0511C67.0615 55.5297 67.6573 55.2318 68.1042 55.4553L73.7651 58.956C74.212 59.254 74.212 59.8498 73.7651 60.0733L68.1042 63.5741C67.6573 63.872 67.0615 63.4996 67.0615 62.9782V56.0511Z"
                  fill="#E63638"
                />
              </svg>
              <p
                class="col-md-12 mx-auto col-8 text-md-center text-left my-lg-3 book_text my-md-2 my-auto"
              >
                Live online classes <span class="d-md-none"><br /></span> with expert trainers
              </p>
            </div>
            <div class="col-lg-3 col-md-6 col-12 d-flex flex-wrap h-100">
              <svg
                class="col-md-6 mx-auto col-4 my-auto"
                width="116"
                height="116"
                viewBox="0 0 116 116"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M58 116C90.0325 116 116 90.0325 116 58C116 25.9675 90.0325 0 58 0C25.9675 0 0 25.9675 0 58C0 90.0325 25.9675 116 58 116Z"
                  fill="#9BC157"
                />
                <path d="M29 45.3125H87V87H29V45.3125Z" fill="white" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M69.6367 78.2567H77.7865C78.9507 78.2567 79.8821 77.3253 79.8821 76.161V70.1069C79.8821 68.9426 78.9507 68.0112 77.7865 68.0112H69.6367C68.4724 68.0112 67.541 68.9426 67.541 70.1069V76.161C67.541 77.3253 68.4724 78.2567 69.6367 78.2567Z"
                  fill="#FCAC31"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M54.0158 78.2567H62.1656C63.3299 78.2567 64.2613 77.3253 64.2613 76.161V70.1069C64.2613 68.9426 63.3299 68.0112 62.1656 68.0112H54.0158C52.8516 68.0112 51.9202 68.9426 51.9202 70.1069V76.161C51.9202 77.5581 52.8516 78.2567 54.0158 78.2567Z"
                  fill="#2881C3"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M70.3154 64.0282H78.4652C79.6294 64.0282 80.5609 63.0968 80.5609 61.9325V55.8784C80.5609 54.7141 79.6294 53.7827 78.4652 53.7827H70.3154C69.1511 53.7827 68.2197 54.7141 68.2197 55.8784V61.9325C68.2197 63.0968 69.1511 64.0282 70.3154 64.0282Z"
                  fill="#2881C3"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M37.716 78.2333H45.8658C47.0301 78.2333 47.9615 77.3018 47.9615 76.1376V70.0835C47.9615 68.9192 47.0301 67.9878 45.8658 67.9878H37.716C36.5518 67.9878 35.6204 68.9192 35.6204 70.0835V76.1376C35.6204 77.5347 36.5518 78.2333 37.716 78.2333Z"
                  fill="#2881C3"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M37.716 64.0282H45.8658C47.0301 64.0282 47.9615 63.0968 47.9615 61.9325V55.8784C47.9615 54.7141 47.0301 53.7827 45.8658 53.7827H37.716C36.5518 53.7827 35.6204 54.7141 35.6204 55.8784V61.9325C35.6204 63.0968 36.5518 64.0282 37.716 64.0282Z"
                  fill="#2881C3"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M54.0158 64.0282H62.1656C63.3299 64.0282 64.2613 63.0968 64.2613 61.9325V55.8784C64.2613 54.7141 63.3299 53.7827 62.1656 53.7827H54.0158C52.8516 53.7827 51.9202 54.7141 51.9202 55.8784V61.9325C51.9202 63.3296 52.8516 64.0282 54.0158 64.0282Z"
                  fill="#2881C3"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M86.6149 25.375H29.5663C27.2378 25.375 25.375 27.2378 25.375 29.3335V45.6331V86.3821C25.375 88.7106 27.2378 90.5734 29.5663 90.5734C31.8948 90.5734 86.6149 90.5734 86.6149 90.5734C88.9434 90.5734 90.8062 88.7106 90.8062 86.3821V45.6331V29.3335C90.5734 27.2378 88.7106 25.375 86.6149 25.375ZM66.124 33.5248C67.2882 33.5248 68.2197 34.4562 68.2197 35.6205C68.2197 36.7847 67.2882 37.7161 66.124 37.7161C64.9597 37.7161 64.0283 36.7847 64.0283 35.6205C64.0283 34.4562 64.9597 33.5248 66.124 33.5248ZM49.8244 33.5248C50.9887 33.5248 51.9201 34.4562 51.9201 35.6205C51.9201 36.7847 50.9887 37.7161 49.8244 37.7161C48.6601 37.7161 47.7287 36.7847 47.7287 35.6205C47.7287 34.4562 48.6601 33.5248 49.8244 33.5248ZM86.6149 84.5193C86.6149 85.6835 85.6835 86.6149 84.5193 86.6149H57.9742H31.4291C30.2649 86.6149 29.3335 85.6835 29.3335 84.5193V45.6331H86.3821L86.6149 84.3591V84.5193Z"
                  fill="#31668B"
                />
              </svg>
              <p
                class="col-md-12 mx-auto col-8 text-md-center text-left my-lg-3 book_text my-md-2 my-auto"
              >
                Six month long extensive program
              </p>
            </div>
            <div class="col-lg-3 col-md-6 col-12 d-flex flex-wrap h-100">
              <svg
                class="col-md-6 mx-auto col-4 my-auto"
                width="116"
                height="116"
                viewBox="0 0 116 116"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M58 116C90.0325 116 116 90.0325 116 58C116 25.9675 90.0325 0 58 0C25.9675 0 0 25.9675 0 58C0 90.0325 25.9675 116 58 116Z"
                  fill="#E63638"
                />
                <rect
                  x="29"
                  y="25.375"
                  width="52.5625"
                  height="65.25"
                  rx="2"
                  fill="white"
                />
                <rect
                  x="38.0625"
                  y="34.4375"
                  width="21.75"
                  height="5.4375"
                  rx="1.5"
                  fill="#F36F2E"
                />
                <rect
                  x="38.0625"
                  y="65.25"
                  width="29"
                  height="5.4375"
                  rx="1.5"
                  fill="#2881C3"
                />
                <rect
                  x="38.0625"
                  y="76.125"
                  width="19.9375"
                  height="5.4375"
                  rx="1.5"
                  fill="#2881C3"
                />
                <rect
                  x="38.0625"
                  y="45.3125"
                  width="29"
                  height="14.5"
                  rx="1.5"
                  fill="#FCAC31"
                />
                <path
                  d="M81.5625 85.1875L77.0312 81.5625L78.8991 76.9904H84.2259L86.0938 81.5625L81.5625 85.1875Z"
                  fill="#51A6E6"
                />
                <path
                  d="M84.2812 32.3125C84.2812 31.4841 83.6097 30.8125 82.7812 30.8125H80.3438C79.5153 30.8125 78.8438 31.4841 78.8438 32.3125V36.25H84.2812V32.3125Z"
                  fill="#084F84"
                />
                <rect
                  x="77.0312"
                  y="36.25"
                  width="9.0625"
                  height="45.3125"
                  fill="#2881C3"
                />
                <path
                  d="M77.0313 38.0625L75.8229 38.0625C75.8229 38.0625 74.6146 38.0625 74.0105 38.9687C73.4063 39.875 73.4063 41.6875 73.4063 41.6875L73.4062 56.1875"
                  stroke="#00B3D5"
                  stroke-linecap="round"
                />
              </svg>
              <p
                class="col-md-12 mx-auto col-8 text-md-center text-left my-lg-3 book_text my-md-2 my-auto"
              >
                Homework challenges <span class="d-md-none"><br /></span> and monthly <span class="d-md-none"><br /></span> competitions to <span class="d-md-none"><br /></span> master the skill
              </p>
            </div>
            <div class="col-lg-3 col-md-6 col-12 d-flex flex-wrap h-100">
              <svg
                class="col-md-6 mx-auto col-4 my-auto"
                width="116"
                height="116"
                viewBox="0 0 116 116"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M58 116C90.0325 116 116 90.0325 116 58C116 25.9675 90.0325 0 58 0C25.9675 0 0 25.9675 0 58C0 90.0325 25.9675 116 58 116Z"
                  fill="#0577BE"
                />
                <path
                  d="M27.6742 60.1455H65.1116C65.2894 60.1713 65.4701 60.1254 65.6141 60.0179C65.758 59.9104 65.8534 59.7502 65.8791 59.5724C65.9049 59.3946 65.859 59.2139 65.7515 59.0699C65.6441 58.926 65.4838 58.8306 65.306 58.8049C64.4969 58.5114 63.7491 58.0705 63.1007 57.5044L54.3127 49.8427C52.8932 48.6374 51.9889 46.9344 51.7856 45.0834C51.6787 43.9412 51.8536 42.7902 52.2951 41.7313C52.7366 40.6725 53.4312 39.7382 54.3179 39.0103C55.2046 38.2824 56.2563 37.7832 57.3809 37.5565C58.5055 37.3297 59.6685 37.3824 60.7679 37.7098C61.761 38.021 62.6755 38.5423 63.4492 39.2382L66.3115 41.6982C66.3929 41.7687 66.4927 41.8144 66.5993 41.8299C66.7058 41.8454 66.8146 41.83 66.9126 41.7855C67.0107 41.7411 67.094 41.6695 67.1525 41.5791C67.2111 41.4888 67.2426 41.3836 67.2433 41.2759V27.8025C67.2433 27.23 67.0158 26.681 66.6111 26.2762C66.2063 25.8714 65.6573 25.644 65.0848 25.644H27.6742C27.1017 25.644 26.5527 25.8714 26.1479 26.2762C25.7431 26.681 25.5157 27.23 25.5157 27.8025V57.967C25.5131 58.2521 25.5669 58.5349 25.6742 58.7991C25.7815 59.0633 25.9401 59.3037 26.1408 59.5062C26.3415 59.7088 26.5803 59.8696 26.8435 59.9793C27.1067 60.089 27.389 60.1455 27.6742 60.1455Z"
                  fill="#F5FBFF"
                />
                <path
                  d="M83.8336 77.057H83.847C84.7344 77.0578 85.6131 77.2328 86.4332 77.572C87.2574 77.913 88.0063 78.4131 88.637 79.0438C89.2678 79.6746 89.7679 80.4235 90.1088 81.2477C90.4498 82.072 90.6248 82.9553 90.6239 83.8473V87.8692C90.6239 88.479 90.3817 89.0638 89.9505 89.495C89.5193 89.9262 88.9345 90.1685 88.3247 90.1685H73.8056C73.1958 90.1685 72.611 89.9262 72.1798 89.495C71.7486 89.0638 71.5064 88.479 71.5064 87.8692V83.8473C71.5055 82.9553 71.6805 82.072 72.0214 81.2477C72.3624 80.4235 72.8625 79.6746 73.4932 79.0438C74.124 78.4131 74.8729 77.913 75.6971 77.572C76.5214 77.2311 77.4047 77.0561 78.2967 77.057H83.8336Z"
                  fill="#FFDF40"
                />
                <path
                  d="M85.8539 66.2133C86.4859 67.1591 86.8232 68.2711 86.8232 69.4086C86.8232 70.9339 86.2173 72.3968 85.1387 73.4754C84.0601 74.554 82.5972 75.1599 81.0718 75.1599C79.9343 75.1599 78.8224 74.8226 77.8766 74.1907C76.9307 73.5587 76.1936 72.6605 75.7583 71.6095C75.323 70.5586 75.2091 69.4022 75.431 68.2866C75.6529 67.1709 76.2007 66.1461 77.005 65.3418C77.8094 64.5374 78.8342 63.9897 79.9498 63.7677C81.0655 63.5458 82.2219 63.6597 83.2728 64.095C84.3237 64.5303 85.222 65.2675 85.8539 66.2133Z"
                  fill="#FFDF40"
                />
                <path
                  d="M55.2313 77.057H60.7681C61.6601 77.0561 62.5435 77.2311 63.3677 77.572C64.192 77.913 64.9409 78.4131 65.5716 79.0438C66.2023 79.6746 66.7025 80.4235 67.0434 81.2477C67.3843 82.072 67.5594 82.9553 67.5585 83.8473V87.8692C67.5585 88.479 67.3163 89.0638 66.8851 89.495C66.4539 89.9262 65.8691 90.1685 65.2593 90.1685H50.7401C50.1303 90.1685 49.5455 89.9262 49.1143 89.495C48.6832 89.0638 48.4409 88.479 48.4409 87.8692V83.8473C48.44 82.9553 48.6151 82.072 48.956 81.2477C49.2969 80.4235 49.7971 79.6746 50.4278 79.0438C51.0585 78.4131 51.8074 77.913 52.6317 77.572C53.4559 77.2311 54.3393 77.0561 55.2313 77.057Z"
                  fill="#FFDF40"
                />
                <path
                  d="M62.7818 66.2133C63.4138 67.1591 63.7511 68.2711 63.7511 69.4086C63.7511 70.9339 63.1451 72.3968 62.0665 73.4754C60.9879 74.554 59.5251 75.1599 57.9997 75.1599C56.8622 75.1599 55.7502 74.8226 54.8044 74.1907C53.8586 73.5587 53.1215 72.6605 52.6861 71.6095C52.2508 70.5586 52.1369 69.4022 52.3589 68.2866C52.5808 67.1709 53.1285 66.1461 53.9329 65.3418C54.7372 64.5374 55.762 63.9897 56.8777 63.7677C57.9933 63.5458 59.1497 63.6597 60.2007 64.095C61.2516 64.5303 62.1498 65.2675 62.7818 66.2133Z"
                  fill="#FFDF40"
                />
                <path
                  d="M43.0799 90.0135C42.801 90.1291 42.502 90.1886 42.2001 90.1886L27.6742 90.1685C27.0644 90.1685 26.4796 89.9262 26.0484 89.495C25.6172 89.0638 25.375 88.479 25.375 87.8692V83.8473C25.3741 82.9553 25.5492 82.072 25.8901 81.2477C26.231 80.4235 26.7312 79.6746 27.3619 79.0438C27.9926 78.4131 28.7415 77.913 29.5658 77.572C30.39 77.2311 31.2734 77.0561 32.1654 77.057H37.7022C38.5965 77.0552 39.4822 77.2302 40.3085 77.572C41.1349 77.9138 41.8855 78.4156 42.5172 79.0486C43.1489 79.6815 43.6492 80.4331 43.9894 81.2601C44.3295 82.0871 44.5028 82.9732 44.4993 83.8674V87.8894C44.4993 88.1913 44.4398 88.4903 44.3243 88.7692C44.2087 89.0482 44.0394 89.3016 43.8259 89.5151C43.6124 89.7286 43.3589 89.898 43.0799 90.0135Z"
                  fill="#FFDF40"
                />
                <path
                  d="M30.145 72.6039C29.513 71.6581 29.1757 70.5461 29.1757 69.4086C29.1757 67.8832 29.7817 66.4204 30.8603 65.3418C31.9389 64.2632 33.4017 63.6572 34.9271 63.6572C36.0646 63.6572 37.1766 63.9945 38.1224 64.6265C39.0682 65.2585 39.8053 66.1567 40.2407 67.2076C40.676 68.2586 40.7899 69.415 40.5679 70.5306C40.346 71.6463 39.7983 72.6711 38.9939 73.4754C38.1896 74.2798 37.1648 74.8275 36.0491 75.0494C34.9335 75.2714 33.7771 75.1575 32.7261 74.7221C31.6752 74.2868 30.777 73.5497 30.145 72.6039Z"
                  fill="#FFDF40"
                />
                <path
                  d="M90.6241 57.4366V45.3708C90.6224 44.6291 90.4738 43.8951 90.187 43.2112C89.9001 42.5273 89.4807 41.9069 88.9528 41.3859C88.425 40.8649 87.7992 40.4536 87.1116 40.1758C86.424 39.8979 85.6881 39.7589 84.9465 39.7669H79.2756C77.8504 39.7674 76.4791 40.3116 75.4413 41.2885L75.3073 41.4159C74.4225 42.2672 70.3067 46.155 67.6589 48.595L60.5334 42.3677C60.2601 42.1297 59.9414 41.9496 59.5965 41.8382C59.2516 41.7269 58.8878 41.6866 58.5269 41.7198C58.166 41.753 57.8156 41.859 57.4969 42.0314C57.1781 42.2039 56.8976 42.4391 56.6723 42.723C56.2391 43.2924 56.0413 44.0066 56.1199 44.7178C56.1985 45.429 56.5475 46.0827 57.0946 46.5438L65.9362 54.2659C66.4351 54.7061 67.0798 54.9451 67.745 54.9364C68.4103 54.9277 69.0486 54.672 69.5358 54.219L73.7052 50.3378V57.4969C73.7052 58.1067 73.9475 58.6915 74.3786 59.1227C74.8098 59.5538 75.3946 59.7961 76.0044 59.7961H88.3249C88.632 59.7962 88.936 59.7348 89.219 59.6155C89.5019 59.4962 89.7581 59.3214 89.9724 59.1015C90.1867 58.8815 90.3548 58.6209 90.4667 58.335C90.5787 58.049 90.6322 57.7435 90.6241 57.4366Z"
                  fill="#42CCE7"
                />
                <path
                  d="M75.277 26.4231C76.3149 25.7345 77.534 25.3698 78.7795 25.3751C80.439 25.3821 82.0284 26.0449 83.2012 27.219C84.374 28.393 85.0351 29.9831 85.0404 31.6426C85.0443 32.8881 84.6783 34.1068 83.9886 35.144C83.2989 36.1812 82.3168 36.9902 81.1666 37.4684C80.0165 37.9466 78.7503 38.0724 77.5286 37.8299C76.3068 37.5874 75.1847 36.9875 74.3044 36.1063C73.4241 35.225 72.8254 34.1022 72.5842 32.8802C72.343 31.6582 72.4701 30.3921 72.9496 29.2425C73.429 28.0929 74.239 27.1116 75.277 26.4231Z"
                  fill="#42CCE7"
                />
              </svg>
              <p
                class="col-md-12 mx-auto col-8 text-md-center text-left my-lg-3 book_text my-md-2 my-auto"
              >
                Demo days with <span class="d-md-none"><br /></span> experts to hone <span class="d-md-none"><br /></span> presentation skills
              </p>
            </div>
          </div>
          <div class="pt-5">
            <RequestCall :head="requestCallHead" />
            <button
              @click="showRequestCall('Book a Free Counselling Call!')"
              ref="btnShow"
              class="px-md-5 mx-auto ab-btn col-lg-4 col-lg-6 col-md-8 col-12"
            >
              Book a Free Counselling Call
            </button>
            <p class="col-lg-6 col-md-8 col-12 mx-auto mt-4" style="font-size: 14px;">
              to know about Avishkaar Online Courses and <span class="d-md-none"><br /></span> select the best subject
              for your kid
            </p>
          </div>
        </div>
      </div>
      <div class="sec_share pt-5 pb-3 position-relative">
        <img
          src="https://images.avishkaar.cc/workflow/vue/hp/ic_round-build-circle.png"
          alt=""
          class="col-md-1 col-3 px-md-0"
          loading="lazy"
        />
        <h2 class="text-white">Share</h2>
        <hr
          class="mt-1"
          style="
            width: 4%;
            margin-left: auto; margin-right: auto;
            background: #fff;
            padding: 2px;
            border-radius: 3.5px;
          "
        />
        <h5 class="text-white pt-4 px-2">
          Share your Prototypes, <span class="d-md-none"><br /></span> Innovations or Gag-Projects
        </h5>
        <p class="text-white px-4" style="font-weight: 300">
          there's space to celebrate ALL your crazy ideas in <span class="d-md-none"><br /></span> the Avishkaar
          global community
        </p>

        <div class="d-flex flex-wrap pb-5 pt-4 container">
          <div class="col-lg-3 col-6 my-lg-0 my-2 px-md-3 px-2">
            <div class="card">
              <div class="card-body pt-md-4 pb-md-5 px-md-2 px-0">
                <!-- 15+ countries SVG -->
                <svg
                  class="col-md-11 col-10"
                  width="138"
                  height="139"
                  viewBox="0 0 138 139"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="69"
                    cy="69.8669"
                    r="68.9333"
                    fill="#FFB118"
                    fill-opacity="0.12"
                  />
                  <ellipse
                    cx="69"
                    cy="69.6424"
                    rx="52.8"
                    ry="52.576"
                    fill="#FFB118"
                  />
                  <ellipse
                    cx="70.0812"
                    cy="69.5036"
                    rx="36.4571"
                    ry="36.3024"
                    fill="#006EC0"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M70.08 105.806C49.9459 105.805 33.6241 89.5522 33.6241 69.5033C33.6241 68.7674 33.6461 68.0367 33.6895 67.3117C41.8584 65.6749 47.3262 67.5249 50.0929 71.1391C51.5206 73.0042 51.7496 75.8088 51.9876 78.7246C52.222 81.5967 52.4653 84.5766 53.8715 86.8728C55.5091 89.5469 59.0392 90.3667 62.2747 91.118C64.6383 91.6669 66.8446 92.1793 68.0409 93.3514C69.6806 94.9579 70.0553 100.902 70.08 105.806Z"
                    fill="#74B500"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M51.9089 38.0255C51.6727 41.874 52.2145 49.6416 56.2151 52.3156C58.6502 53.9433 61.8542 54.4146 64.6435 54.8249C67.7435 55.2808 70.3313 55.6615 70.7824 57.4704C70.9573 58.172 71.0251 59.1242 71.1024 60.2101C71.4038 64.4433 71.8498 70.708 79.3514 72.0755C86.8921 73.4501 90.4911 68.0662 91.348 65.2025C91.9192 62.6251 93.4045 57.1267 94.7756 55.7521C95.6443 54.8811 99.5409 54.654 103.369 54.6774C97.6747 42.0193 84.9122 33.2012 70.0814 33.2012C63.4641 33.2012 57.2586 34.9567 51.9089 38.0255Z"
                    fill="#74B500"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M103.124 84.8633C98.8698 93.9238 90.9673 100.946 81.2988 104.056V93.7372C81.2988 90.7792 82.5722 84.8633 87.6656 84.8633H103.124Z"
                    fill="#74B500"
                  />
                </svg>
                <h3 class="m-0 pt-md-4" style="font-size: 28px">15+</h3>
                <p class="m-0">Countries</p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-6 my-lg-0 my-2 px-md-3 px-2">
            <div class="card">
              <div class="card-body pt-md-4 pb-md-5 px-md-2 px-0">
                <!-- innovators svg -->
                <svg
                  class="col-md-11 col-10"
                  width="138"
                  height="139"
                  viewBox="0 0 138 139"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="69"
                    cy="69.4001"
                    r="68.9333"
                    fill="#F36F2E"
                    fill-opacity="0.12"
                  />
                  <ellipse
                    cx="69"
                    cy="69.3416"
                    rx="52.8"
                    ry="52.576"
                    fill="#F36F2E"
                  />
                  <path
                    d="M49.9333 80.7517V89.9319H86.6V80.7517C86.6 75.1905 82.7111 70.8652 77.7111 70.8652H58.9016C54.0603 70.8652 49.9333 75.2788 49.9333 80.7517Z"
                    fill="#F9DC5C"
                  />
                  <path
                    d="M68.4191 66.8928C74.0982 66.8928 78.7376 62.2535 78.7376 56.5743C78.7376 50.8952 74.0982 46.2559 68.4191 46.2559C62.7399 46.2559 58.1006 50.8952 58.1006 56.5743C58.1806 62.2535 62.7399 66.8928 68.4191 66.8928Z"
                    fill="#F9DC5C"
                  />
                  <path
                    d="M44.3424 68.4134C48.8217 68.4134 52.4212 64.7339 52.4212 60.3346C52.4212 55.9352 48.8217 52.1758 44.3424 52.1758C39.8631 52.1758 36.1836 55.8552 36.1836 60.3346C36.1836 64.8139 39.8631 68.4134 44.3424 68.4134Z"
                    fill="#FCAC31"
                  />
                  <path
                    d="M36.8236 71.373C32.9842 71.373 29.7847 74.4926 29.7847 78.412V84.9711H47.0621V79.6118C47.0621 76.2523 48.5819 73.2928 50.9016 71.373H36.8236Z"
                    fill="#FCAC31"
                  />
                  <path
                    d="M92.5754 68.4135C97.0547 68.4135 100.654 64.734 100.654 60.3347C100.654 55.9353 96.9748 52.2559 92.5754 52.2559C88.0961 52.2559 84.4966 55.9353 84.4966 60.3347C84.4966 64.734 88.0961 68.4135 92.5754 68.4135Z"
                    fill="#FCAC31"
                  />
                  <path
                    d="M100.014 71.373H86.0964C88.4161 73.3728 89.8559 76.3323 89.8559 79.6118V84.9711H107.133V78.412C107.133 74.4926 104.014 71.373 100.014 71.373Z"
                    fill="#FCAC31"
                  />
                </svg>
                <h3 class="m-0 pt-md-4" style="font-size: 28px">200,000+</h3>
                <p class="m-0">Innovators</p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-6 my-lg-0 my-2 px-md-3 px-2">
            <div class="card">
              <div class="card-body pt-md-4 pb-md-5 px-md-2 px-0">
                <!-- schools svg -->
                <svg
                  class="col-md-11 col-10"
                  width="138"
                  height="139"
                  viewBox="0 0 138 139"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="69"
                    cy="69.8669"
                    r="68.9333"
                    fill="#006DBE"
                    fill-opacity="0.12"
                  />
                  <ellipse
                    cx="69"
                    cy="69.6424"
                    rx="52.8"
                    ry="52.576"
                    fill="#1170B7"
                  />
                  <rect
                    x="68.6306"
                    y="36.1328"
                    width="17.6302"
                    height="12.5396"
                    fill="#F36F2E"
                  />
                  <rect
                    x="39.6667"
                    y="78.7676"
                    width="11.3337"
                    height="25.0791"
                    fill="#F36F2E"
                  />
                  <rect
                    x="87.5203"
                    y="78.7676"
                    width="11.3337"
                    height="25.0791"
                    fill="#F36F2E"
                  />
                  <path
                    d="M51.0005 67.4423V103.846H87.5202V67.4423L68.9023 57.4492L51.0005 67.4423Z"
                    fill="#FCAC31"
                  />
                  <rect
                    x="67.3713"
                    y="36.1328"
                    width="2.5186"
                    height="22.5712"
                    fill="#FCAC31"
                  />
                  <ellipse
                    cx="68.6307"
                    cy="76.26"
                    rx="6.29651"
                    ry="6.26979"
                    fill="white"
                  />
                  <rect
                    x="64.8528"
                    y="90.0527"
                    width="8.81511"
                    height="13.7935"
                    fill="white"
                  />
                </svg>
                <h3 class="m-0 pt-md-4" style="font-size: 28px">1500+</h3>
                <p class="m-0">Schools</p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-6 my-lg-0 my-2 px-md-3 px-2">
            <div class="card">
              <div class="card-body pt-md-4 pb-md-5 px-md-2 px-0">
                <!-- projects svg -->
                <svg
                  width="138"
                  height="139"
                  viewBox="0 0 138 139"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="69.0666"
                    cy="69.8669"
                    r="68.9333"
                    fill="#9BC157"
                    fill-opacity="0.12"
                  />
                  <circle cx="69.0666" cy="69.8664" r="52.8" fill="#9BC157" />
                  <path
                    d="M94.7566 66.5759V66.5744L94.7574 54.1669V47.2396H86.5694C83.0455 47.2396 80.1861 44.3803 80.1861 40.8571V31.7344H51.998C49.8871 31.7344 48.1677 33.4364 48.1677 35.5639V72.1399V88.5127V95.7976C48.1677 97.9078 49.8871 99.6098 51.998 99.6264H90.9263C93.0539 99.6098 94.7566 97.9078 94.7566 95.7976V66.5759Z"
                    fill="#1470B5"
                  />
                  <path
                    d="M82.7383 33.6758L93.0877 44.6876H86.5686C84.4577 44.6876 82.7383 42.9856 82.7383 40.858V33.6758Z"
                    fill="white"
                  />
                  <path
                    d="M39.9304 90.3173H49.5489C49.7962 90.9769 50.0573 91.6227 50.3321 92.2548C50.4414 92.498 50.6192 92.7042 50.8436 92.8481C51.0681 92.9921 51.3296 93.0676 51.5963 93.0655H53.8085C54.1239 94.6186 54.9665 96.0149 56.1936 97.0178C57.4206 98.0208 58.9567 98.5687 60.5415 98.5687C62.1263 98.5687 63.6624 98.0208 64.8894 97.0178C66.1165 96.0149 66.9591 94.6186 67.2745 93.0655H69.4455C69.7122 93.0676 69.9737 92.9921 70.1981 92.8481C70.4226 92.7042 70.6003 92.498 70.7097 92.2548C70.9845 91.6227 71.2456 90.9769 71.4929 90.3173H81.1114C81.4291 90.3251 81.7396 90.2225 81.9901 90.0271C82.2406 89.8317 82.4157 89.5555 82.4855 89.2456C82.4855 89.1081 85.2337 76.0682 73.8975 68.7306C71.9189 55.6631 61.9568 45.811 61.5308 45.3713C61.274 45.1195 60.9287 44.9785 60.569 44.9785C60.2093 44.9785 59.864 45.1195 59.6071 45.3713C59.14 45.8248 49.1779 55.6769 47.2405 68.7306C35.8081 76.0682 38.5563 89.1081 38.5563 89.2456C38.6261 89.5555 38.8012 89.8317 39.0517 90.0271C39.3022 90.2225 39.6127 90.3251 39.9304 90.3173Z"
                    fill="white"
                  />
                  <rect
                    x="53.6709"
                    y="99.9414"
                    width="2.74815"
                    height="6.87038"
                    rx="1.37408"
                    fill="white"
                  />
                  <rect
                    x="64.6636"
                    y="99.9414"
                    width="2.74815"
                    height="6.87038"
                    rx="1.37408"
                    fill="white"
                  />
                  <rect
                    x="59.1675"
                    y="102.689"
                    width="2.74815"
                    height="8.24446"
                    rx="1.37408"
                    fill="white"
                  />
                  <path
                    d="M52.9331 73.5335C52.9331 69.0784 56.5447 65.4668 60.9998 65.4668C65.4549 65.4668 69.0664 69.0784 69.0664 73.5335C69.0664 77.9886 65.4549 81.6001 60.9998 81.6001C56.5447 81.6001 52.9331 77.9886 52.9331 73.5335Z"
                    fill="#FCAC31"
                  />
                  <path
                    d="M82.3154 90.1755C84.4703 78.8162 78.8598 71.5205 74.9885 68.8687C74.6422 68.6314 74.1915 68.9404 74.2318 69.3583C74.3823 70.9181 74.5565 74.2709 74.1023 79.6077C73.6301 85.1571 72.471 88.4003 71.8575 89.7837C71.6994 90.1404 71.9616 90.5802 72.3518 90.5802H81.8275C82.065 90.5802 82.2711 90.4089 82.3154 90.1755Z"
                    fill="#EAF4FB"
                    stroke="#EAF4FB"
                  />
                  <path
                    d="M38.7444 89.9704C36.5895 78.6112 42.2 71.3155 46.0713 68.6636C46.4176 68.4264 46.8684 68.7353 46.828 69.1532C46.6775 70.713 46.5033 74.0658 46.9575 79.4026C47.4298 84.952 48.5889 88.1952 49.2023 89.5787C49.3605 89.9353 49.0982 90.3751 48.7081 90.3751H39.2323C38.9948 90.3751 38.7887 90.2038 38.7444 89.9704Z"
                    fill="#EAF4FB"
                    stroke="#EAF4FB"
                  />
                </svg>

                <h3 class="m-0 pt-md-4" style="font-size: 28px">Countless</h3>
                <p class="m-0">Projects</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 startStudent px-5 pb-5 pt-md-4 mb-md-4">
          <div class="px-md-4" v-if="homeData.projects">
            <h2 class="text-white mb-4">Star Student Projects</h2>
            <VueSlickCarousel v-bind="starSettings" class="px-md-2">
              <template v-for="(prj, idx) in homeData.projects">
                <HomeProjectsSection :prj="prj" :key="idx" />
              </template>
              <!-- <template v-for="(prj, idx) in homeData.projects">
                <HomeProjectsSection :prj="prj" :key="idx" />
              </template> -->
              <!-- <div
                v-for="(project, projectKey) in homeData.projects"
                :key="projectKey"
              >
                <CarouselCard
                  type="project_card"
                  :user_name="project.user_name"
                  :user_image="project.profile_img"
                  :projectImage="'https://images.avishkaar.cc/campaigns/robotility/robotility_ad_banner_v2.png'"
                />
              </div> -->
              <!--<CarouselCard :type="'startStudent'" :user_name="'test'" :user_image="'https://images.avishkaar.cc/workflow/hp_v1/user.jpg'" :projectImage="'https://images.avishkaar.cc/campaigns/robotility/robotility_ad_banner_v2.png'"/>
                  <CarouselCard :type="'startStudent'" :user_name="'test'" :user_image="'https://images.avishkaar.cc/workflow/hp_v1/user.jpg'" :projectImage="'https://images.avishkaar.cc/campaigns/robotility/robotility_ad_banner_v2.png'"/>
                  <CarouselCard :type="'startStudent'" :user_name="'test'" :user_image="'https://images.avishkaar.cc/workflow/hp_v1/user.jpg'" :projectImage="'https://images.avishkaar.cc/campaigns/robotility/robotility_ad_banner_v2.png'"/>
                  <CarouselCard :type="'startStudent'" :user_name="'test'" :user_image="'https://images.avishkaar.cc/workflow/hp_v1/user.jpg'" :projectImage="'https://images.avishkaar.cc/campaigns/robotility/robotility_ad_banner_v2.png'"/>-->
            </VueSlickCarousel>
          </div>
        </div>
        <a :href="get_web_path + '/projects'" class="px-5 ab-btn"
          >View All Projects by Avishkaaris</a
        >

        <div class="col-12 startStudent px-md-5 px-1 pt-5 mt-5">
          <div class="px-md-4 pb-md-0 pb-5">
            <div
              class="d-md-block d-none"
              style="position: absolute; margin-top: -10%"
            >
              <svg
                width="153"
                height="136"
                viewBox="0 0 153 136"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M138.656 68H114.75V48.5714C114.755 43.4201 116.771 38.4811 120.357 34.8385C123.942 31.1959 128.804 29.1475 133.875 29.1429H136.266C137.209 29.145 138.142 28.9581 139.013 28.5927C139.884 28.2274 140.676 27.6909 141.342 27.014C142.009 26.3371 142.537 25.5331 142.897 24.6483C143.256 23.7635 143.441 22.8151 143.439 21.8578V7.28636C143.441 6.32911 143.257 5.38089 142.897 4.49613C142.537 3.61137 142.009 2.80748 141.343 2.1306C140.676 1.45372 139.885 0.917183 139.014 0.551775C138.143 0.186368 137.21 -0.000713605 136.267 0.00126896H133.875C127.596 -0.000542545 121.378 1.25452 115.576 3.69474C109.775 6.13496 104.503 9.71252 100.063 14.223C95.6228 18.7335 92.101 24.0886 89.6987 29.9822C87.2965 35.8758 86.0609 42.1925 86.0625 48.5714V121.429C86.0635 125.293 87.575 128.999 90.2648 131.731C92.9545 134.463 96.6023 135.999 100.406 136H138.656C142.46 135.999 146.108 134.463 148.798 131.731C151.487 128.999 152.999 125.293 153 121.429V82.5714C152.999 78.7072 151.487 75.0014 148.798 72.269C146.108 69.5365 142.46 68.001 138.656 68ZM52.5938 68H28.6875V48.5714C28.6921 43.4201 30.7085 38.4811 34.2941 34.8385C37.8798 31.1959 42.7416 29.1475 47.8125 29.1429H50.2037C51.146 29.1449 52.0794 28.9578 52.9504 28.5924C53.8213 28.227 54.6126 27.6904 55.2789 27.0135C55.9452 26.3367 56.4734 25.5328 56.8331 24.648C57.1928 23.7632 57.377 22.815 57.375 21.8578V7.28636C57.3771 6.329 57.1931 5.38065 56.8334 4.49574C56.4738 3.61084 55.9457 2.8068 55.2794 2.12979C54.6131 1.45278 53.8217 0.916127 52.9507 0.550641C52.0796 0.185155 51.1461 -0.00196755 50.2037 1.55994e-05H47.8125C41.5332 -0.00179598 35.315 1.2533 29.5133 3.69361C23.7117 6.13391 18.4401 9.71158 14 14.2222C9.55982 18.7328 6.03805 24.088 3.63588 29.9818C1.23371 35.8756 -0.00178135 42.1924 1.9277e-06 48.5714V121.429C0.000983199 125.293 1.51251 128.999 4.20227 131.731C6.89204 134.463 10.5399 135.999 14.3438 136H52.5938C56.3976 135.999 60.0455 134.463 62.7352 131.731C65.425 128.999 66.9365 125.293 66.9375 121.429V82.5714C66.9365 78.7072 65.425 75.0014 62.7352 72.269C60.0455 69.5365 56.3976 68.001 52.5938 68Z"
                  fill="#085280"
                />
              </svg>
            </div>
            <h2 class="text-white col-lg-6 col-12 mx-auto">
              Hear from the <span class="d-md-none"><br /></span> Avishkaaris themselves
            </h2>
            <VueSlickCarousel v-bind="TestimonialsSettings" class="px-2">
              <div class="px-1">
                <p class="mb-1 pl-1 text-left text-white">Students</p>
                <b-card
                  style="border: none; border-radius: 10px"
                  class="mb-2 h-100 hp_testimonial"
                >
                  <div
                    @click="openYtModal('WYwYBcxSsw8')"
                    style="height: auto; overflow: hidden; background: black"
                  >
                    <div class="h-100">
                      <img
                        style="
                          cursor: pointer;
                          border-radius: 0px 0px 20px 20px;
                        "
                        src="https://images.avishkaar.cc/workflow/vue/student.webp"
                        class="w-100 h-100"
                        alt="Students"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </b-card>
              </div>
              <div class="px-1">
                <p class="mb-1 pl-1 text-left text-white">Parents</p>
                <b-card
                  style="border: none; border-radius: 10px"
                  class="mb-2 h-100 hp_testimonial"
                >
                  <div
                    @click="openYtModal('dNUY23P-b0M')"
                    style="height: auto; overflow: hidden; background: black"
                  >
                    <div class="h-100">
                      <img
                        style="
                          cursor: pointer;
                          border-radius: 0px 0px 20px 20px;
                        "
                        src="https://images.avishkaar.cc/workflow/vue/parent.webp"
                        class="w-100 h-100"
                        alt="Parents"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </b-card>
              </div>
              <div class="px-1">
                <p class="mb-1 pl-1 text-left text-white">Educators</p>
                <b-card
                  style="border: none; border-radius: 10px"
                  class="mb-2 h-100 hp_testimonial"
                >
                  <div
                    @click="openYtModal('6DlrQWEnEMI')"
                    style="height: auto; overflow: hidden; background: black"
                  >
                    <div class="h-100">
                      <img
                        style="
                          cursor: pointer;
                          border-radius: 0px 0px 20px 20px;
                        "
                        src="https://images.avishkaar.cc/workflow/vue/teacher.webp"
                        class="w-100 h-100"
                        alt="Educators"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </b-card>
              </div>
            </VueSlickCarousel>
          </div>
          <div
            class="mx-auto hear-carousel-block"
            style="position: relative; top: -40px;"
            v-if="homeData.testimonials"
          >
            <VueSlickCarousel v-bind="TextTestimonialsSettings">
              <div
                v-for="(testimonial, testimonialKey) in homeData.testimonials"
                :key="testimonialKey"
              >
                <Testimonials
                  :type="'hp_text_testimonial'"
                  :user_name="testimonial.user_name"
                  :user_type="testimonial.user_designation"
                  :win_text="testimonial.text"
                  :media="testimonial.user_image"
                />
              </div>
              <!--<Testimonials :type="'hp_text_testimonial'" :user_name="'Test'" :user_type="'Parent'" :win_text="'“Best Robotics Kit’s out there, My kids love playing with them”'" :media="'https://images.avishkaar.cc/workflow/hp_v1/user.jpg'"/>
                  <Testimonials :type="'hp_text_testimonial'" :user_name="'Test'" :user_type="'Parent'" :win_text="'“Best Robotics Kit’s out there, My kids love playing with them”'" :media="'https://images.avishkaar.cc/workflow/hp_v1/user.jpg'"/>
                  <Testimonials :type="'hp_text_testimonial'" :user_name="'Test'" :user_type="'Parent'" :win_text="'“Best Robotics Kit’s out there, My kids love playing with them”'" :media="'https://images.avishkaar.cc/workflow/hp_v1/user.jpg'"/>
                  <Testimonials :type="'hp_text_testimonial'" :user_name="'Test'" :user_type="'Parent'" :win_text="'“Best Robotics Kit’s out there, My kids love playing with them”'" :media="'https://images.avishkaar.cc/workflow/hp_v1/user.jpg'"/>-->
            </VueSlickCarousel>
          </div>
        </div>
        <div class="svg_user position-absolute">
          <svg
            width="200"
            height="188"
            viewBox="0 0 200 188"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="100.668"
              cy="60"
              r="60"
              fill="#2A7EB3"
              fill-opacity="0.5"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M199.001 187.501C199.001 132.732 154.603 88.334 99.8346 88.334C45.0664 88.334 0.667969 132.732 0.667969 187.501H199.001Z"
              fill="#2074A9"
              fill-opacity="0.5"
            />
          </svg>
        </div>
        <div>
          <!-- <a href="" class="ab-btn-none text-white px-5 py-2" style="border: 2px solid rgba(255, 255, 255, 0.2);box-sizing: border-box;border-radius: 28.5px">Read all Stories</a> -->
        </div>
      </div>

      <div class="pt-5 join-head">
        <h2 data-v-fae5bece="" class="mb-3 col-md-10 mx-auto pt-4">
          Join the Avishkaar <span class="d-md-none"><br /></span> Community
        </h2>
        <div class="py-md-5 mt-md-5">
          <div class="join col-md-10 col-12 mx-auto py-md-5">
            <b-card
              no-body
              class="py-5"
              style="
                box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.07);
                border-radius: 16px;
              "
            >
              <b-tabs align="center">
                <b-tab active>
                  <template #title>
                    <div class="join-comm-head">
                      <img
                        src="https://images.avishkaar.cc/workflow/vue/hp/join1.webp"
                        alt="Students"
                        loading="lazy"
                      />
                      <p class="m-0 text-white">Students</p>
                    </div>
                  </template>
                  <div class="px-md-5 pt-5">
                    <div class="d-flex flex-wrap" style="align-items: baseline; font-size: 16px;">
                      <div class="col-lg-3 col-md-6 d-flex flex-wrap">
                        <img
                          class="col-md-6 mx-auto col-4 my-auto pb-3"
                          src="https://images.avishkaar.cc/workflow/vue/hp/icon2.png"
                          alt=""
                          loading="lazy"
                        />
                        <p
                          class="col-md-12 mx-auto col-8 text-md-center text-left my-lg-3 book_text my-md-2 my-auto"
                        >
                          Attend monthly expert <span class="d-md-none"><br /></span> Webinars
                        </p>
                      </div>
                      <div class="col-lg-3 col-md-6 d-flex flex-wrap">
                        <img
                          class="col-md-6 mx-auto col-4 my-auto pb-3"
                          src="https://images.avishkaar.cc/workflow/vue/hp/showcase.png"
                          alt=""
                          loading="lazy"
                        />
                        <p
                          class="col-md-12 mx-auto col-8 text-md-center text-left my-lg-3 book_text my-md-2 my-auto"
                        >
                          Six month long <span class="d-md-none"><br /></span> extensive program
                        </p>
                      </div>
                      <div
                        class="col-lg-3 col-md-6 d-flex flex-wrap h-100 w-100"
                      >
                        <img
                          class="col-md-6 mx-auto col-4 my-auto pb-3"
                          src="https://images.avishkaar.cc/workflow/vue/hp/win.png"
                          alt=""
                          loading="lazy"
                        />
                        <p
                          class="col-md-12 mx-auto col-8 text-md-center text-left my-lg-3 book_text my-md-2 my-auto w-100"
                        >
                          Participate and Win in <span class="d-md-none"><br /></span> Monthly Global <span class="d-md-none"><br /></span> Competitions
                        </p>
                      </div>
                      <div class="col-lg-3 col-md-6 d-flex flex-wrap h-100">
                        <img
                          class="col-md-6 mx-auto col-4 my-auto pb-3"
                          src="https://images.avishkaar.cc/workflow/vue/hp/icon4.png"
                          alt=""
                          loading="lazy"
                        />
                        <p
                          class="col-md-12 mx-auto col-8 text-md-center text-left my-lg-3 book_text my-md-2 my-auto"
                        >
                          Demo days with <span class="d-md-none"><br /></span> experts to hone <span class="d-md-none"><br /></span> presentation skills
                        </p>
                      </div>
                    </div>
                    <div class="pt-md-5 pt-4 col-12 row m-0">
                      <a
                        v-if="$cookies.get('userAccess')"
                        href="https://www.facebook.com/groups/letsavishkaar"
                        target="_blank"
                        class="ab-btn col-md-5 col-12 mx-auto"
                        >Join Today</a
                      >
                      <a
                        v-else
                        :href="`${get_web_path}${(get_web_path.endsWith('/')) ? 'login?return_url=fb_student' : '/login?return_url=fb_student'}`"
                        class="ab-btn col-md-5 col-12 mx-auto"
                      >
                        Join Today
                      </a>
                    </div>
                  </div>
                </b-tab>
                <b-tab>
                  <template #title>
                    <div class="join-comm-head">
                      <img
                        src="https://images.avishkaar.cc/workflow/vue/hp/join2.webp"
                        alt="Parents"
                        loading="lazy"
                      />
                      <p class="m-0 text-white">Parents</p>
                    </div>
                  </template>
                  <div class="px-md-5 pt-5">
                    <div class="d-flex flex-wrap">
                      <div class="col-lg-3 col-md-6 d-flex flex-wrap h-100">
                        <img
                          class="col-md-6 mx-auto col-4 my-auto pb-3"
                          src="https://images.avishkaar.cc/workflow/vue/hp/icon2.png"
                          alt=""
                          loading="lazy"
                        />
                        <p
                          class="col-md-12 mx-auto col-8 text-md-center text-left my-lg-3 book_text my-md-2 my-auto"
                        >
                          Attend monthly expert Webinars
                        </p>
                      </div>
                      <div class="col-lg-3 col-md-6 d-flex flex-wrap h-100">
                        <img
                          class="col-md-6 mx-auto col-4 my-auto pb-3"
                          src="https://images.avishkaar.cc/workflow/vue/hp/icon1.png"
                          alt="Exciting projects"
                          loading="lazy"
                        />
                        <p
                          class="col-md-12 mx-auto col-8 text-md-center text-left my-lg-3 book_text my-md-2 my-auto"
                        >
                          Look at exciting projects from young innovators across
                          the world
                        </p>
                      </div>
                      <div class="col-lg-3 col-md-6 d-flex flex-wrap h-100">
                        <img
                          class="col-md-6 mx-auto col-4 my-auto pb-3"
                          src="https://images.avishkaar.cc/workflow/vue/hp/icon5.png"
                          alt=""
                          loading="lazy"
                        />
                        <p
                          class="col-md-12 mx-auto col-8 text-md-center text-left my-lg-3 book_text my-md-2 my-auto"
                        >
                          Tips & tricks on parenting innovators
                        </p>
                      </div>
                      <div class="col-lg-3 col-md-6 d-flex flex-wrap h-100">
                        <img
                          class="col-md-6 mx-auto col-4 my-auto pb-3"
                          src="https://images.avishkaar.cc/workflow/vue/hp/icon4.png"
                          alt=""
                          loading="lazy"
                        />
                        <p
                          class="col-md-12 mx-auto col-8 text-md-center text-left my-lg-3 book_text my-md-2 my-auto"
                        >
                          Monthly Newsletter with Updates from the Tech-worlds
                        </p>
                      </div>
                    </div>
                    <div class="pt-md-5 pt-4 col-12 row m-0">
                      <a
                        v-if="$cookies.get('userAccess')"
                        href="https://www.facebook.com/groups/letsavishkaar"
                        target="_blank"
                        class="ab-btn col-md-5 col-12 mx-auto"
                        >Join Today</a
                      >
                      <a
                        v-else
                        :href="`${get_web_path}${(get_web_path.endsWith('/')) ? 'login?return_url=fb_student' : '/login?return_url=fb_student'}`"
                        class="ab-btn col-md-5 col-12 mx-auto"
                      >
                        Join Today
                      </a>
                    </div>
                  </div>
                </b-tab>
                <b-tab>
                  <template #title>
                    <div class="join-comm-head">
                      <img
                        src="https://images.avishkaar.cc/workflow/vue/hp/join3.webp"
                        alt="Educators"
                        loading="lazy"
                      />
                      <p class="m-0 text-white">Educators</p>
                    </div>
                  </template>
                  <div class="px-md-5 pt-5">
                    <div class="d-flex flex-wrap">
                      <div class="col-lg-3 col-md-6 d-flex flex-wrap h-100">
                        <img
                          class="col-md-6 mx-auto col-4 my-auto pb-3"
                          src="https://images.avishkaar.cc/workflow/vue/hp/icon2.png"
                          alt=""
                          loading="lazy"
                        />
                        <p
                          class="col-md-12 mx-auto col-8 text-md-center text-left my-lg-3 book_text my-md-2 my-auto"
                        >
                          Attend monthly expert Webinars
                        </p>
                      </div>
                      <div class="col-lg-3 col-md-6 d-flex flex-wrap h-100">
                        <img
                          class="col-md-6 mx-auto col-4 my-auto pb-3"
                          src="https://images.avishkaar.cc/workflow/vue/hp/icon1.png"
                          alt=""
                          loading="lazy"
                        />
                        <p
                          class="col-md-12 mx-auto col-8 text-md-center text-left my-lg-3 book_text my-md-2 my-auto"
                        >
                          Look at exciting projects from young innovators across
                          the world
                        </p>
                      </div>
                      <div class="col-lg-3 col-md-6 d-flex flex-wrap h-100">
                        <img
                          class="col-md-6 mx-auto col-4 my-auto pb-3"
                          src="https://images.avishkaar.cc/workflow/vue/hp/icon5.png"
                          alt=""
                          loading="lazy"
                        />
                        <p
                          class="col-md-12 mx-auto col-8 text-md-center text-left my-lg-3 book_text my-md-2 my-auto"
                        >
                          Tips & tricks on parenting innovators
                        </p>
                      </div>
                      <div class="col-lg-3 col-md-6 d-flex flex-wrap h-100">
                        <img
                          class="col-md-6 mx-auto col-4 my-auto pb-3"
                          src="https://images.avishkaar.cc/workflow/vue/hp/icon4.png"
                          alt=""
                          loading="lazy"
                        />
                        <p
                          class="col-md-12 mx-auto col-8 text-md-center text-left my-lg-3 book_text my-md-2 my-auto"
                        >
                          Monthly Newsletter with Updates from the Tech-worlds
                        </p>
                      </div>
                    </div>
                    <div class="pt-md-5 pt-4 col-12 row m-0">
                      <a
                        v-if="$cookies.get('userAccess')"
                        href="https://www.facebook.com/groups/avishkaarforeducation"
                        target="_blank"
                        class="ab-btn col-md-5 col-12 mx-auto"
                        >Join Today</a
                      >
                      <a
                        v-else
                        :href="`${get_web_path}${(get_web_path.endsWith('/')) ? 'login?return_url=fb_educator' : '/login?return_url=fb_educator'}`"
                        class="ab-btn col-md-5 col-12 mx-auto"
                      >
                        Join Today
                      </a>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </b-card>
          </div>
        </div>
      </div>
      <div class="win_sec py-5">
        <div class="pb-4">
          <svg
            class="col-md-3 col-4"
            width="104"
            height="104"
            viewBox="0 0 104 104"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M52.0001 8.66699C28.0801 8.66699 8.66675 28.0803 8.66675 52.0003C8.66675 75.9203 28.0801 95.3337 52.0001 95.3337C75.9201 95.3337 95.3334 75.9203 95.3334 52.0003C95.3334 28.0803 75.9201 8.66699 52.0001 8.66699Z"
              fill="#9BC157"
            />
            <path
              d="M72.753 39.6063H65.7702V36.2076H66.141C67.1915 36.2076 67.9948 35.4043 67.9948 34.3538C67.9948 33.3033 67.1915 32.5 66.141 32.5H37.7158C36.6653 32.5 35.862 33.3033 35.862 34.3538C35.862 35.4043 36.6653 36.2076 37.7158 36.2076H38.0865V39.6063H31.1038C30.0533 39.6063 29.25 40.4096 29.25 41.4601V43.3757C29.25 49.6169 33.452 55.0548 39.446 56.7232L42.8447 57.6502C42.9683 57.8355 43.1536 58.0209 43.2772 58.1445C44.8839 59.7511 46.7995 60.8016 48.9623 61.296V65.0036C48.9623 66.3631 47.85 67.4754 46.4905 67.4754C45.9962 67.4754 45.5636 67.908 45.5636 68.4023V69.8236C45.5636 70.3179 45.1311 70.7505 44.6367 70.7505H43.4008C42.9065 70.7505 42.4739 71.183 42.4739 71.6774V76.8681C42.4739 77.3624 42.9065 77.795 43.4008 77.795H60.3942C60.8885 77.795 61.3211 77.3624 61.3211 76.8681V71.6156C61.3211 71.1212 60.8885 70.6887 60.3942 70.6887H59.1583C58.6639 70.6887 58.2314 70.2561 58.2314 69.7618V68.3405C58.2314 67.8462 57.7988 67.4136 57.3045 67.4136C55.945 67.4136 54.8327 66.3013 54.8327 64.9418V61.2342C56.9955 60.7398 58.9111 59.6894 60.5178 58.0827C60.7031 57.8973 60.8267 57.7737 60.9503 57.5884L64.349 56.6614C70.343 55.0548 74.545 49.5551 74.545 43.3139V41.3983C74.6068 40.4714 73.7417 39.6063 72.753 39.6063ZM32.9576 43.3757V43.3139H38.0865C38.2101 45.4767 38.5809 49.3698 40.0639 53.0156C35.9238 51.7179 32.9576 47.8249 32.9576 43.3757ZM55.2653 72.3571V74.3345C55.2653 74.6435 55.0181 74.8289 54.7709 74.8289H49.1477C48.8387 74.8289 48.6533 74.5817 48.6533 74.3345V72.3571C48.6533 72.0481 48.9005 71.801 49.1477 71.801H54.7709C55.0181 71.801 55.2653 72.0481 55.2653 72.3571ZM58.6021 45.9711L56.4394 48.0103C56.254 48.1957 56.1304 48.5046 56.1922 48.7518L56.7483 51.6561C56.9337 52.7066 55.8214 53.4482 54.8945 52.9538L52.2992 51.5325C52.052 51.409 51.743 51.409 51.4958 51.5325L48.9005 52.9538C47.9736 53.4482 46.8613 52.6448 47.0467 51.6561L47.6028 48.7518C47.6646 48.5046 47.541 48.1957 47.3556 48.0103L45.2546 45.9711C44.5131 45.2296 44.8839 43.9937 45.9344 43.8083L48.8387 43.4375C49.0859 43.3757 49.333 43.2522 49.4566 42.9432L50.7543 40.286C51.1869 39.3591 52.5463 39.3591 52.9789 40.286L54.2766 42.9432C54.4002 43.1904 54.6473 43.3757 54.8945 43.4375L57.7988 43.8083C58.9111 43.9937 59.3437 45.2914 58.6021 45.9711ZM70.8991 43.3757C70.8991 47.8249 67.9948 51.6561 63.7928 53.0156C65.2759 49.3698 65.6467 45.4767 65.7702 43.3139H70.8991V43.3757Z"
              fill="white"
            />
          </svg>
          <h2 style="color: #9bc157 !important">Win</h2>
          <hr
            class="mt-1"
            style="
              width: 3%;
              background: #9bc157;
              margin-left: auto; margin-right: auto;
              padding: 2px;
              border-radius: 3.5px;
            "
          />
        </div>
        <h2>Win at Avishkaar League</h2>
        <p class="px-4">Asia’s Biggest Coding and Robotics <span class="d-md-none"><br /></span> International Competition</p>
        <!-- <img
          class="d-md-block d-none w-100"
          src="https://images.avishkaar.cc/workflow/vue/hp/win_image.webp"
          alt="Image 1"
        />
        <img
          class="d-md-none d-block w-100"
          src="https://images.avishkaar.cc/workflow/vue/hp/win_img.webp"
          alt="Image 1"
        /> -->
        <picture>
          <source
            media="(min-width: 576px)"
            srcset="https://images.avishkaar.cc/workflow/vue/hp/win_image.webp"
            width="100%"
            height="100%"
            loading="lazy"
          >
          <img
            src="https://images.avishkaar.cc/workflow/vue/hp/win_img.webp"
            alt="Avishkaar League"
            width="100%"
            height="100%"
            loading="lazy"
          >
        </picture>
        <div class="win_inner py-5 px-3">
          <div
            class="col-md-10 bg-white mx-auto mb-5 py-5"
            style="border-radius: 16px"
          >
            <h2>Benefits</h2>
            <div class="d-flex flex-wrap pt-4">
              <div class="col-lg-3 col-md-6 col-12 d-flex flex-wrap h-100">
                <svg
                  class="col-md-6 mx-auto col-4 my-auto pb-2"
                  width="96"
                  height="96"
                  viewBox="0 0 96 96"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M48 96C74.5097 96 96 74.5097 96 48C96 21.4903 74.5097 0 48 0C21.4903 0 0 21.4903 0 48C0 74.5097 21.4903 96 48 96Z"
                    fill="#1170B7"
                  />
                  <rect
                    x="25.7267"
                    y="22.5"
                    width="58.5"
                    height="36.882"
                    rx="2"
                    transform="rotate(12.0931 25.7267 22.5)"
                    fill="#1170B7"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.5 34.9987C13.5 32.6212 15.4282 30.693 17.8056 30.693H22.5225L23.6326 25.8449C24.1636 23.5277 26.4729 22.0796 28.7908 22.6092L64.0784 30.693H69.4734H69.5803H69.5868L69.6915 30.6995H69.6937L69.7856 30.7038L69.82 30.7059L69.8358 30.7081L69.9075 30.7146H69.9133L69.9147 30.7167L70.0145 30.7275H70.0216L70.0496 30.7318L70.12 30.7425H70.13L70.1465 30.7469L70.2197 30.7576L70.2362 30.7619L70.2599 30.7662L70.3295 30.7791L70.3417 30.7813L70.3991 30.7942L70.4465 30.805L70.4536 30.8071L70.5355 30.8279L70.5491 30.8301L70.5534 30.8322L70.6474 30.8574L70.6531 30.8595L70.6704 30.8638L70.7378 30.8825L70.7543 30.8889L70.7665 30.8932L70.8397 30.9162L70.8555 30.9227L70.8706 30.927L70.9545 30.9564L71.0385 30.988L71.0536 30.9944L71.0658 30.9987L71.1469 31.0325L71.1569 31.0368L71.2387 31.0726L71.2466 31.077L71.2559 31.0813L71.332 31.1171L71.3542 31.1279L71.4246 31.1638L71.436 31.1681L71.4418 31.1702L71.5171 31.2126L71.5379 31.2233L71.6176 31.2678L71.6212 31.27L71.68 31.3059L71.6886 31.3102L71.7288 31.3353L71.7396 31.3418L71.7963 31.3776L71.8802 31.4322L71.8846 31.4343L71.9499 31.4802L71.9664 31.491L71.9671 31.4932L71.9915 31.5097L72.0374 31.5434L72.0503 31.5542L72.0754 31.5728L72.1293 31.613L72.1336 31.6173L72.1824 31.6575L72.1953 31.6661L72.2304 31.6955L72.2355 31.6998L72.2864 31.7443L72.2936 31.7486L72.3087 31.7637L72.356 31.806L72.3697 31.819L72.3883 31.8355L72.4371 31.8814L72.445 31.89L72.4586 31.9029L72.5038 31.9474L72.5189 31.9625L72.534 31.9776L72.5813 32.0278L72.5914 32.0364L72.6065 32.0529L72.6474 32.0974L72.6617 32.1125L72.6746 32.1275L72.7198 32.1778L72.755 32.2179L72.7651 32.2287L72.7974 32.2689L72.8088 32.2818L72.8512 32.3364L72.8634 32.3514L72.8935 32.3895L72.9093 32.4103L72.9344 32.444L72.9746 32.4985L72.976 32.5007L73.0012 32.5344C73.0313 32.5789 73.0607 32.6227 73.0901 32.6672L73.1031 32.688L73.1152 32.7045L73.1432 32.7504L73.1626 32.782L79.1575 34.1548C81.4725 34.6772 82.9214 36.9857 82.3903 39.3043L75.6606 68.6825C75.1303 71.0011 72.8203 72.4477 70.5024 71.9182L59.6974 69.4438H17.8056C15.4282 69.4438 13.5 67.5156 13.5 65.1382V34.9987ZM73.314 33.0497L73.3126 33.0475L73.3112 33.0454L73.3104 33.041L73.3083 33.0389L73.3069 33.0367L73.3061 33.0346L73.3054 33.0332L73.314 33.0497ZM73.6427 33.918L73.642 33.9137L73.6391 33.9072V33.905L73.6176 33.8232L73.6427 33.918ZM73.6499 33.9474L73.6599 33.9897L73.6448 33.9266L73.6434 33.9223L73.6427 33.9201L73.6499 33.9474ZM24.7306 30.693H54.4359L28.31 24.7096C27.1503 24.4427 25.9964 25.1682 25.7316 26.3264L24.7306 30.693ZM73.2717 32.9678L73.2939 33.0116L73.2731 32.9743L73.2724 32.97L73.2717 32.9678ZM73.3061 33.0346L73.314 33.0497L73.3126 33.0475L73.3112 33.0454L73.3104 33.041L73.3083 33.0389L73.3069 33.0367L73.3061 33.0346ZM73.3205 33.0647L73.3219 33.0669L73.3234 33.069L73.3205 33.0647ZM73.6434 33.9223L73.6499 33.9474L73.6492 33.9452L73.6477 33.9409V33.9388L73.647 33.9345L73.6463 33.9323V33.928L73.6448 33.9266L73.6434 33.9223ZM73.779 35.1228V65.1382C73.779 67.5156 71.8508 69.4438 69.4734 69.4438H69.3406L70.9825 69.8199C72.1429 70.0847 73.2968 69.3613 73.5623 68.2009L80.292 38.8228C80.5568 37.6646 79.8335 36.51 78.6731 36.2452L73.779 35.1228Z"
                    fill="#FCAC31"
                  />
                  <rect
                    x="49.5"
                    y="33"
                    width="22.5"
                    height="34.5"
                    rx="2"
                    fill="white"
                  />
                  <path
                    d="M34.6136 45.0604L39.6761 40.3693C40.6699 39.4484 42.2227 39.5064 43.1447 40.5014C44.0667 41.4963 44.0064 43.0491 43.0126 43.9699L37.9501 48.6611C38.2297 53.284 38.6251 61.4203 37.9836 62.0148C37.0834 62.8489 36.2493 61.9488 36.2493 61.9488C35.6838 61.3385 34.0954 56.3142 33.1259 53.1314L29.158 56.8082C29.4827 59.4252 29.7983 62.9073 29.2462 63.4189C28.346 64.2531 27.5119 63.3529 27.5119 63.3529C26.6778 62.4528 25.1416 57.1839 25.1416 57.1839C25.1416 57.1839 20.0048 55.2515 19.1706 54.3514C18.3365 53.4512 19.2367 52.6171 19.2367 52.6171C19.7888 52.1055 23.2357 52.6825 25.8215 53.2076L29.7894 49.5308C26.6895 48.3221 21.8006 46.3563 21.2351 45.746C20.4009 44.8458 21.3011 44.0117 21.3011 44.0117C21.9426 43.4173 30.0247 44.4307 34.6136 45.0604Z"
                    fill="#9A5D00"
                  />
                  <path
                    d="M58.7093 59.4518V61.6046C58.7093 62.1995 58.2271 62.681 57.6329 62.681C57.0388 62.681 56.5565 62.1995 56.5565 61.6046V59.4518C56.5565 58.8569 57.0388 58.3754 57.6329 58.3754C58.2271 58.3754 58.7093 58.8569 58.7093 59.4518Z"
                    fill="#2881C3"
                  />
                  <path
                    d="M58.7093 52.9933V55.1462C58.7093 55.7411 58.2271 56.2226 57.6329 56.2226C57.0388 56.2226 56.5565 55.7411 56.5565 55.1462V52.9933C56.5565 52.3984 57.0388 51.9169 57.6329 51.9169C58.2271 51.9169 58.7093 52.3984 58.7093 52.9933Z"
                    fill="#2881C3"
                  />
                  <path
                    d="M58.7093 46.5349V48.6877C58.7093 49.2826 58.2271 49.7641 57.6329 49.7641C57.0388 49.7641 56.5565 49.2826 56.5565 48.6877V46.5349C56.5565 45.94 57.0388 45.4585 57.6329 45.4585C58.2271 45.4585 58.7093 45.94 58.7093 46.5349Z"
                    fill="#2881C3"
                  />
                  <path
                    d="M58.7093 40.0764V42.2292C58.7093 42.8241 58.2271 43.3056 57.6329 43.3056C57.0388 43.3056 56.5565 42.8241 56.5565 42.2292V40.0764C56.5565 39.4815 57.0388 39 57.6329 39C58.2271 39 58.7093 39.4815 58.7093 40.0764Z"
                    fill="#2881C3"
                  />
                </svg>
                <p
                  class="col-md-12 mx-auto col-8 text-md-center text-left my-lg-3 book_text my-md-2 my-auto"
                  style="color: rgba(48, 48, 48, 0.87); font-size: 16px"
                >
                  Sponsored <span class="d-md-none"><br /></span> International Trips
                </p>
              </div>
              <div class="col-lg-3 col-md-6 col-12 d-flex flex-wrap h-100">
                <svg
                  class="col-md-6 mx-auto col-4 my-auto"
                  width="96"
                  height="96"
                  viewBox="0 0 96 96"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M48 96C74.5097 96 96 74.5097 96 48C96 21.4903 74.5097 0 48 0C21.4903 0 0 21.4903 0 48C0 74.5097 21.4903 96 48 96Z"
                    fill="#FCAC31"
                  />
                  <path
                    d="M69.8183 32.8226V44.3316C68.9319 44.1407 68.0182 44.0453 67.091 44.0453C66.0001 44.0453 64.9501 44.168 63.941 44.4135C63.6955 44.1953 63.3683 44.0453 63.0001 44.0453H33.0001C32.2501 44.0453 31.6364 44.6589 31.6364 45.4089C31.6364 46.1589 32.2501 46.7725 33.0001 46.7725H58.9228C55.6092 49.2544 53.4546 53.2225 53.4546 57.6816H31.3228C30.6273 55.1726 28.6773 53.2362 26.1819 52.5407V32.8226C28.6773 32.1271 30.6273 30.1907 31.3228 27.6816H64.6773C65.3728 30.1907 67.3228 32.1271 69.8183 32.8226ZM31.6364 34.4998C31.6364 35.2498 32.2501 35.8635 33.0001 35.8635H46.6364C47.3864 35.8635 48.0001 35.2498 48.0001 34.4998C48.0001 33.7498 47.3864 33.1362 46.6364 33.1362H33.0001C32.2501 33.1362 31.6364 33.7498 31.6364 34.4998ZM64.3637 39.9544C64.3637 39.2044 63.7501 38.5907 63.0001 38.5907H33.0001C32.2501 38.5907 31.6364 39.2044 31.6364 39.9544C31.6364 40.7044 32.2501 41.318 33.0001 41.318H63.0001C63.7501 41.318 64.3637 40.7044 64.3637 39.9544Z"
                    fill="white"
                  />
                  <path
                    d="M78 49.4727V25.0227C78 21.9818 74.9455 19.5 71.1818 19.5H24.8182C21.0545 19.5 18 21.9818 18 25.0227V60.3409C18 63.3818 21.0545 65.8636 24.8182 65.8636H56.1818C54.9818 64.2682 54.1364 62.4 53.7545 60.4091H30.2045C29.5091 60.4091 28.9227 59.8909 28.8545 59.1955C28.6105 56.9727 26.8909 55.2546 24.6682 55.0091C23.9727 54.9409 23.4545 54.3545 23.4545 53.6591V31.7045C23.4545 31.0091 23.9727 30.4227 24.6682 30.3545C26.8909 30.1091 28.6091 28.3909 28.8545 26.1682C28.9227 25.4727 29.5091 24.9545 30.2045 24.9545H65.7955C66.4909 24.9545 67.0773 25.4727 67.1455 26.1682C67.3895 28.3909 69.1091 30.1091 71.3318 30.3545C72.0273 30.4227 72.5455 31.0091 72.5455 31.7045V45.1909C72.6818 45.2455 72.8318 45.3136 72.9682 45.3818C75 46.35 76.7045 47.7545 78 49.4727Z"
                    fill="#0073C9"
                  />
                  <path
                    d="M76.4454 64.1864C78 62.2636 78.8182 59.9182 78.8182 57.4091C78.8182 53.1545 76.4318 49.3773 72.6 47.5636C71.1273 46.8546 69.5591 46.5 67.9091 46.5C61.8955 46.5 57 51.3955 57 57.4091C57 58.0227 57.0409 58.5546 57.1227 58.95C57.4364 61.3227 58.5682 63.5455 60.2864 65.1955C60.5455 65.4545 60.8182 65.7 61.0909 65.9182C61.9227 66.5864 62.8364 67.1318 63.8182 67.5273C65.1 68.0455 66.4773 68.3182 67.9091 68.3182C69.3409 68.3182 70.7318 68.0455 72 67.5136C72.9818 67.1318 73.9091 66.5864 74.7273 65.9182C75.3545 65.4136 75.9273 64.8409 76.4454 64.1864Z"
                    fill="#00528E"
                  />
                  <path
                    d="M67.9091 71.0455C69.7132 71.0455 71.445 70.7032 72.99 70.0555C73.59 69.8209 74.1695 69.5373 74.7273 69.2155V77.8636C74.7273 78.3818 74.4409 78.8591 73.9773 79.0773C73.7864 79.1864 73.5682 79.2273 73.3636 79.2273C73.0773 79.2273 72.7909 79.1318 72.5455 78.9546L67.9091 75.4773L63.2727 78.9546C62.8636 79.2682 62.3046 79.3091 61.8409 79.0773C61.3773 78.8591 61.0909 78.3818 61.0909 77.8636V69.2141C61.6432 69.5359 62.2118 69.8195 62.7968 70.0555C64.4223 70.7127 66.1418 71.0455 67.9091 71.0455Z"
                    fill="#00528E"
                  />
                  <path
                    d="M74.19 53.8882C74.7805 53.8882 75.3041 54.2686 75.4869 54.8305C75.6696 55.3923 75.4691 56.0073 74.9905 56.355L72.0601 58.485L73.1796 61.9309C73.3623 62.4927 73.1632 63.1077 72.6846 63.4555C72.4446 63.63 72.1637 63.7159 71.8828 63.7159C71.6019 63.7159 71.3196 63.6286 71.081 63.4555L68.1505 61.3255L65.2214 63.4555C64.7441 63.8032 64.0978 63.8032 63.6178 63.4555C63.1405 63.1077 62.94 62.4927 63.1228 61.9309L64.2423 58.485L61.3119 56.355C60.8346 56.0073 60.6341 55.3923 60.8169 54.8305C60.9996 54.2686 61.5219 53.8882 62.1137 53.8882H65.7355L66.855 50.4423C67.0378 49.8805 67.5614 49.5 68.1519 49.5C68.7423 49.5 69.266 49.8805 69.4487 50.4423L70.5682 53.8882H74.19Z"
                    fill="#F9DC5C"
                  />
                </svg>
                <p
                  class="col-md-12 mx-auto col-8 text-md-center text-left my-lg-3 book_text my-md-2 my-auto"
                  style="color: rgba(48, 48, 48, 0.87); font-size: 16px"
                >
                  Certification & Recommendation for your college application
                </p>
              </div>
              <div class="col-lg-3 col-md-6 col-12 d-flex flex-wrap h-100">
                <svg
                  class="col-md-6 mx-auto col-4 my-auto"
                  width="96"
                  height="96"
                  viewBox="0 0 96 96"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M48 96C74.5097 96 96 74.5097 96 48C96 21.4903 74.5097 0 48 0C21.4903 0 0 21.4903 0 48C0 74.5097 21.4903 96 48 96Z"
                    fill="#00ACC5"
                  />
                  <path
                    d="M77.2682 48.3184C77.2682 47.1888 76.7345 46.1216 75.8541 45.4547C76.0053 44.343 75.6317 43.2313 74.8135 42.4575C74.0398 41.6659 72.9192 41.2924 71.8075 41.4258C71.1404 40.5542 70.091 40.0117 68.9525 40.0117C67.8053 40.0117 66.7647 40.5364 66.0977 41.4258C64.9949 41.2925 63.8743 41.6659 63.1005 42.4397C62.2822 43.2313 61.9087 44.343 62.0599 45.4548C61.1794 46.1218 60.6458 47.189 60.6458 48.3185C60.6458 49.4481 61.1794 50.5064 62.0599 51.1734C61.9265 52.2051 62.2377 53.2545 62.9582 54.0372C63.0026 54.0906 63.0561 54.1529 63.1094 54.2062C63.3229 54.4019 63.5362 54.5708 63.7941 54.7398C64.4879 55.1489 65.306 55.3179 66.1066 55.2201C66.5334 55.7892 67.1382 56.2162 67.8142 56.4296C68.1521 56.5541 68.5257 56.6164 68.9525 56.6164H68.9614C69.3884 56.6164 69.7441 56.563 70.0642 56.4474C70.758 56.2251 71.3716 55.7893 71.8075 55.2112C71.9587 55.2379 72.1099 55.2467 72.2611 55.2467C72.9192 55.2467 73.5596 55.0689 74.1377 54.722C74.3778 54.562 74.5913 54.4019 74.778 54.224C74.8403 54.1706 74.9114 54.0995 74.9825 54.0017C75.6762 53.2279 75.9875 52.1962 75.8541 51.1823C76.7434 50.5153 77.2682 49.4746 77.2682 48.3184ZM73.1682 48.3184C73.1682 50.6397 71.2827 52.5252 68.9525 52.5252C66.6312 52.5252 64.7457 50.6397 64.7457 48.3184C64.7457 46.0061 66.6312 44.1206 68.9525 44.1206C71.2827 44.1206 73.1682 46.0061 73.1682 48.3184Z"
                    fill="#FFD51E"
                  />
                  <path
                    d="M68.9524 45.8994C67.6184 45.8994 66.5244 46.9845 66.5244 48.3185C66.5244 49.6615 67.6184 50.7465 68.9524 50.7465C70.2954 50.7465 71.3894 49.6615 71.3894 48.3185C71.3893 46.9844 70.2954 45.8994 68.9524 45.8994Z"
                    fill="#0073C9"
                  />
                  <path
                    d="M65.3504 57.0163C66.0619 57.6655 66.9157 58.0924 67.814 58.2792L64.888 64.3092C64.7457 64.6204 64.4344 64.8162 64.0876 64.8162H64.0432C63.6785 64.7895 63.3672 64.5583 63.2516 64.2203L62.5668 62.2548L60.6013 62.9397C60.2633 63.0553 59.8897 62.9574 59.6497 62.6907C59.4095 62.4238 59.3561 62.0325 59.5073 61.7123L62.3355 55.8779C63.1714 56.5359 64.2209 56.954 65.3504 57.0163Z"
                    fill="#0073C9"
                  />
                  <path
                    d="M78.2553 62.6907C78.0152 62.9575 77.6416 63.0553 77.3037 62.9398L75.3381 62.2549L74.6622 64.2204C74.5465 64.5584 74.2352 64.7896 73.8706 64.8162H73.8173C73.4793 64.8162 73.168 64.6206 73.0168 64.3093L70.0908 58.2704C70.9802 58.0836 71.834 57.6656 72.5544 57.0164C73.6839 56.9541 74.7246 56.536 75.5694 55.8779L78.3887 61.7123C78.5488 62.0325 78.4954 62.4239 78.2553 62.6907Z"
                    fill="#0073C9"
                  />
                  <path
                    d="M36.1489 70.1998H63.5941V66.8164H36.1489V70.1998ZM56.06 67.6185H57.9972V69.3973H56.06V67.6185ZM51.2883 67.6185H53.226V69.3973H51.2883V67.6185ZM46.517 67.6185H48.4543V69.3973H46.517V67.6185ZM41.7452 67.6185H43.6825V69.3973H41.7452V67.6185Z"
                    fill="#0073C9"
                  />
                  <path
                    d="M68.9524 38.2331C69.2548 38.2331 69.5483 38.2597 69.8417 38.3131V29.4104C69.8417 25.604 66.7468 22.5 62.9313 22.5H27.6497C27.7297 22.5622 27.8098 22.6333 27.8898 22.7135C29.1083 23.9497 29.8109 25.5328 29.8819 27.2314C29.8997 27.3382 29.8997 27.4449 29.8997 27.5517V74.1107C29.8997 74.5998 30.291 75 30.7891 75H68.9522C69.4502 75 69.8416 74.5998 69.8416 74.1107V61.8282L68.9522 59.9962L66.4887 65.0834C66.2605 65.5895 65.86 65.996 65.3727 66.2614V71.089C65.3727 71.5801 64.9745 71.9784 64.4834 71.9784H35.2595C34.7684 71.9784 34.3702 71.5801 34.3702 71.089V65.9269C34.3702 65.4358 34.7684 65.0376 35.2595 65.0376H61.6732C61.6372 64.959 61.599 64.8816 61.5705 64.7989L61.4727 64.5232L61.1881 64.621C60.8945 64.7188 60.61 64.7633 60.3165 64.7633C59.5605 64.7633 58.8312 64.4432 58.3243 63.8829C57.6039 63.0825 57.435 61.9262 57.8974 60.9569L61.0458 54.4555C60.5745 53.6995 60.2987 52.8279 60.2543 51.9207C59.3738 50.9425 58.8668 49.6528 58.8668 48.3187C58.8668 46.9847 59.3738 45.695 60.2543 44.7168C60.3166 43.3738 60.8769 42.1198 61.8641 41.1593C62.7713 40.261 64.0253 39.7096 65.3327 39.6295C66.3109 38.7311 67.5827 38.2331 68.9524 38.2331ZM46.5171 59.7998H35.0224V58.021H46.517V59.7998H46.5171ZM46.5171 55.3594H35.0224V53.5806H46.517V55.3594H46.5171ZM57.0289 50.919H35.0224V49.1402H57.0288V50.919H57.0289ZM57.0289 46.4786H35.0224V44.6999H57.0288V46.4786H57.0289ZM57.0289 42.0382H35.0224V40.2595H57.0288V42.0382H57.0289ZM64.4835 37.5975H35.0224V35.8187H64.4835V37.5975ZM64.4835 33.1571H35.0224V31.3783H64.4835V33.1571ZM64.4835 28.7167H35.0224V26.9379H64.4835V28.7167Z"
                    fill="white"
                  />
                  <path
                    d="M28.1211 27.5516V39.6916C28.1211 40.1896 27.7209 40.581 27.2317 40.581H18.8893C18.4002 40.581 18 40.1896 18 39.6916V27.5516C18 24.8301 20.2234 22.5622 22.9449 22.5H23.0606C24.4124 22.5 25.6753 23.0247 26.6359 23.9764C27.5875 24.9369 28.1211 26.2087 28.1211 27.5516Z"
                    fill="#FCAC31"
                  />
                </svg>
                <p
                  class="col-md-12 mx-auto col-8 text-md-center text-left my-lg-3 book_text my-md-2 my-auto"
                  style="color: rgba(48, 48, 48, 0.87); font-size: 16px;"
                >
                  Platform to develop your ideas to products and even get them
                  to be patented
                </p>
              </div>
              <div class="col-lg-3 col-md-6 col-12 d-flex flex-wrap h-100">
                <svg
                  class="col-md-6 mx-auto col-4 my-auto"
                  width="96"
                  height="96"
                  viewBox="0 0 96 96"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M48 96C74.5097 96 96 74.5097 96 48C96 21.4903 74.5097 0 48 0C21.4903 0 0 21.4903 0 48C0 74.5097 21.4903 96 48 96Z"
                    fill="#0577BE"
                  />
                  <path
                    d="M35.9712 48.6462C31.1021 48.2115 26.5718 45.9711 23.2709 42.3655C19.97 38.7598 18.1374 34.0498 18.1333 29.1614V25.5998C18.1333 24.1843 18.6956 22.8268 19.6965 21.8259C20.6974 20.825 22.0549 20.2627 23.4704 20.2627C24.8858 20.2627 26.2434 20.825 27.2442 21.8259C28.2451 22.8268 28.8074 24.1843 28.8074 25.5998C28.8077 26.0715 28.9953 26.5239 29.3289 26.8575C29.6625 27.1911 30.1149 27.3787 30.5866 27.379H34.2634C34.7353 27.379 35.1879 27.5664 35.5215 27.9001C35.8552 28.2337 36.0426 28.6863 36.0426 29.1582C36.0426 29.63 35.8552 30.0826 35.5215 30.4162C35.1879 30.7499 34.7353 30.9374 34.2634 30.9374H30.5866C29.1729 30.9348 27.8178 30.3721 26.8182 29.3725C25.8186 28.3728 25.2558 27.0177 25.2533 25.604C25.2539 25.1317 25.0668 24.6786 24.7332 24.3442C24.3997 24.0098 23.9469 23.8217 23.4746 23.8211C23.0023 23.8205 22.5492 24.0076 22.2148 24.3412C21.8804 24.6747 21.6923 25.1275 21.6917 25.5998V29.1614C21.6994 33.1626 23.2028 37.0164 25.9067 39.9658C28.6106 42.9152 32.3195 44.7471 36.305 45.1016C36.7704 45.1517 37.1974 45.383 37.4935 45.7455C37.7896 46.1081 37.931 46.5726 37.8871 47.0386C37.8432 47.5047 37.6175 47.9346 37.259 48.2355C36.9004 48.5364 36.4377 48.6839 35.9712 48.6462Z"
                    fill="#FFBE40"
                  />
                  <path
                    d="M59.2054 47.0398C59.1617 46.5707 59.3055 46.1034 59.6053 45.74C59.9051 45.3766 60.3366 45.1467 60.8054 45.1006C64.7784 44.7411 68.472 42.9041 71.1559 39.9528C73.8398 37.0014 75.3187 33.1505 75.3004 29.1614V25.5998C75.3004 25.1279 75.1129 24.6753 74.7792 24.3417C74.4456 24.008 73.993 23.8206 73.5212 23.8206C73.0493 23.8206 72.5968 24.008 72.2631 24.3417C71.9294 24.6753 71.742 25.1279 71.742 25.5998C71.7394 27.0135 71.1767 28.3686 70.1771 29.3682C69.1774 30.3678 67.8223 30.9306 66.4086 30.9331H62.8502C62.6166 30.9331 62.3852 30.8871 62.1694 30.7977C61.9535 30.7082 61.7574 30.5772 61.5922 30.412C61.427 30.2468 61.2959 30.0506 61.2065 29.8348C61.117 29.6189 61.071 29.3875 61.071 29.1539C61.071 28.9202 61.117 28.6889 61.2065 28.473C61.2959 28.2572 61.427 28.061 61.5922 27.8958C61.7574 27.7306 61.9535 27.5995 62.1694 27.5101C62.3852 27.4207 62.6166 27.3747 62.8502 27.3747H66.4086C66.8791 27.3736 67.33 27.1862 67.6628 26.8537C67.9956 26.5211 68.1832 26.0703 68.1846 25.5998C68.1846 24.1843 68.7469 22.8268 69.7478 21.8259C70.7487 20.825 72.1062 20.2627 73.5217 20.2627C74.9372 20.2627 76.2947 20.825 77.2956 21.8259C78.2965 22.8268 78.8588 24.1843 78.8588 25.5998V29.1614C78.8808 34.0378 77.0726 38.7451 73.7917 42.3529C70.5108 45.9606 65.9959 48.2063 61.1393 48.6462C60.6702 48.6902 60.2027 48.5465 59.8393 48.2466C59.4758 47.9468 59.246 47.5151 59.2001 47.0462L59.2054 47.0398Z"
                    fill="#FF9F40"
                  />
                  <path
                    d="M62.847 20.2666H34.2604C33.789 20.2672 33.3371 20.4549 33.004 20.7885C32.671 21.1222 32.4841 21.5744 32.4844 22.0458V39.8367C32.4903 43.1396 33.52 46.3594 35.4316 49.0529C37.3431 51.7463 40.0427 53.781 43.1585 54.8767V68.5301H53.8327V54.8799C56.9618 53.7902 59.678 51.7606 61.6099 49.0685C63.5417 46.3764 64.5948 43.1533 64.6252 39.8399V22.0458C64.6253 21.8122 64.5794 21.5809 64.4901 21.365C64.4008 21.1492 64.2699 20.953 64.1048 20.7878C63.9396 20.6226 63.7436 20.4915 63.5278 20.4021C63.312 20.3126 63.0806 20.2666 62.847 20.2666V20.2666Z"
                    fill="#FFDF40"
                  />
                  <path
                    d="M53.8294 54.8799C56.9586 53.7902 59.6748 51.7606 61.6066 49.0685C63.5385 46.3764 64.5916 43.1533 64.622 39.8399V22.0458C64.6223 21.5746 64.4355 21.1225 64.1027 20.7889C63.7699 20.4553 63.3183 20.2674 62.847 20.2666H48.4961V68.5386H53.8294V54.8799Z"
                    fill="#FFBE40"
                  />
                  <path
                    d="M57.5817 33.984C57.4791 33.6682 57.2901 33.3875 57.0362 33.1736C56.7823 32.9596 56.4736 32.821 56.1449 32.7733L51.9615 32.1653L50.0906 28.3744C49.9271 28.0968 49.694 27.8667 49.4143 27.7068C49.1346 27.547 48.818 27.4629 48.4959 27.4629C48.1737 27.4629 47.8572 27.547 47.5775 27.7068C47.2978 27.8667 47.0647 28.0968 46.9012 28.3744L45.0303 32.1653L40.8468 32.7733C40.5182 32.8208 40.2095 32.9592 39.9556 33.1731C39.7016 33.3869 39.5126 33.6676 39.4099 33.9833C39.3073 34.299 39.295 34.6371 39.3746 34.9594C39.4542 35.2817 39.6223 35.5753 39.8601 35.8069L42.8863 38.7584L42.1727 42.9248C42.1164 43.2519 42.1528 43.5882 42.2777 43.8957C42.4027 44.2032 42.6112 44.4696 42.8797 44.6648C43.1482 44.8599 43.466 44.976 43.797 44.9999C44.1281 45.0238 44.4592 44.9545 44.753 44.8L48.4948 42.8352L52.2367 44.8C52.5304 44.9545 52.8616 45.0238 53.1926 44.9999C53.5237 44.976 53.8414 44.8599 54.1099 44.6648C54.3784 44.4696 54.587 44.2032 54.7119 43.8957C54.8369 43.5882 54.8732 43.2519 54.817 42.9248L54.1034 38.7584L57.1316 35.8069C57.3692 35.5753 57.5372 35.2818 57.6167 34.9597C57.6963 34.6376 57.6842 34.2996 57.5817 33.984Z"
                    fill="#FFBE40"
                  />
                  <path
                    d="M54.1109 44.6635C54.3792 44.4684 54.5876 44.2023 54.7126 43.895C54.8376 43.5878 54.8741 43.2517 54.8181 42.9248L54.1045 38.7584L57.1349 35.8101C57.3727 35.5785 57.5409 35.2849 57.6205 34.9626C57.7 34.6403 57.6878 34.3021 57.5851 33.9864C57.4824 33.6707 57.2934 33.3901 57.0394 33.1763C56.7855 32.9624 56.4768 32.824 56.1482 32.7765L51.9647 32.1685L50.0949 28.3744C49.9405 28.0876 49.7087 27.8501 49.4257 27.6888C49.1428 27.5275 48.8203 27.4491 48.4949 27.4624V42.8352L52.2367 44.8C52.5305 44.9551 52.862 45.0246 53.1934 45.0005C53.5247 44.9763 53.8427 44.8595 54.1109 44.6635Z"
                    fill="#FF9F40"
                  />
                  <path
                    d="M62.7284 73.8766H60.9492V68.5432C60.9499 68.3092 60.9044 68.0773 60.8153 67.8609C60.7262 67.6445 60.5952 67.4478 60.4299 67.2821C60.2646 67.1164 60.0682 66.9849 59.852 66.8953C59.6358 66.8057 59.404 66.7596 59.17 66.7598H37.8175C37.5838 66.7596 37.3524 66.8056 37.1364 66.8949C36.9205 66.9843 36.7243 67.1153 36.5591 67.2806C36.3938 67.4458 36.2628 67.642 36.1734 67.8579C36.0841 68.0739 36.0381 68.3053 36.0383 68.539V73.8723H34.2591C34.0255 73.8727 33.7942 73.9192 33.5786 74.009C33.363 74.0988 33.1671 74.2302 33.0023 74.3957C32.8375 74.5613 32.7069 74.7576 32.618 74.9737C32.529 75.1897 32.4836 75.4211 32.4841 75.6547V79.2131C32.484 79.4468 32.5299 79.6782 32.6193 79.8941C32.7086 80.1101 32.8397 80.3062 33.0049 80.4715C33.1702 80.6367 33.3664 80.7678 33.5823 80.8572C33.7982 80.9465 34.0296 80.9924 34.2633 80.9923H62.7284C62.9621 80.9924 63.1935 80.9465 63.4094 80.8572C63.6254 80.7678 63.8216 80.6367 63.9868 80.4715C64.152 80.3062 64.2831 80.1101 64.3724 79.8941C64.4618 79.6782 64.5077 79.4468 64.5076 79.2131V75.6547C64.5076 75.4211 64.4616 75.1898 64.3721 74.974C64.2827 74.7582 64.1516 74.5621 63.9864 74.397C63.8212 74.2319 63.625 74.1009 63.4092 74.0116C63.1933 73.9223 62.962 73.8764 62.7284 73.8766Z"
                    fill="#484848"
                  />
                  <path
                    d="M64.5078 79.2131V75.6547C64.508 75.421 64.4621 75.1896 64.3727 74.9737C64.2833 74.7577 64.1523 74.5615 63.987 74.3963C63.8218 74.231 63.6256 74.1 63.4097 74.0106C63.1937 73.9213 62.9623 73.8753 62.7286 73.8755H60.9494V68.5422C60.95 68.3082 60.9044 68.0765 60.8152 67.8602C60.726 67.6439 60.595 67.4473 60.4298 67.2817C60.2645 67.1161 60.0682 66.9848 59.852 66.8952C59.6359 66.8057 59.4042 66.7596 59.1702 66.7598H48.4961V80.9923H62.7286C62.9623 80.9924 63.1937 80.9465 63.4097 80.8572C63.6256 80.7678 63.8218 80.6367 63.987 80.4715C64.1523 80.3062 64.2833 80.1101 64.3727 79.8941C64.4621 79.6782 64.508 79.4468 64.5078 79.2131Z"
                    fill="#545454"
                  />
                  <path
                    d="M52.0535 72.0967H44.9367C44.4648 72.0967 44.0123 72.2841 43.6786 72.6178C43.3449 72.9515 43.1575 73.404 43.1575 73.8759C43.1575 74.3478 43.3449 74.8003 43.6786 75.1339C44.0123 75.4676 44.4648 75.6551 44.9367 75.6551H52.0535C52.5254 75.6551 52.9779 75.4676 53.3116 75.1339C53.6452 74.8003 53.8327 74.3478 53.8327 73.8759C53.8327 73.404 53.6452 72.9515 53.3116 72.6178C52.9779 72.2841 52.5254 72.0967 52.0535 72.0967Z"
                    fill="#545454"
                  />
                  <path
                    d="M53.8294 73.8759C53.8297 73.4047 53.6429 72.9526 53.3101 72.619C52.9773 72.2854 52.5257 72.0975 52.0545 72.0967H48.4961V75.6551H52.0545C52.5257 75.6542 52.9773 75.4664 53.3101 75.1328C53.6429 74.7992 53.8297 74.3471 53.8294 73.8759Z"
                    fill="#484848"
                  />
                </svg>
                <p
                  class="col-md-12 mx-auto col-8 text-md-center text-left my-lg-3 book_text my-md-2 my-auto"
                  style="color: rgba(48, 48, 48, 0.87); font-size: 16px"
                >
                  Prizes worth Rs. 5 lacs
                </p>
              </div>
            </div>
          </div>
          <div class="px-md-5 dozen-student" v-if="homeData.irc_stories">
            <h5 class="text-white col-lg-8 col-12 mx-auto">
              Dozens of Students have won <span class="d-md-none"><br /></span> fully paid scholarship to <span class="d-md-none"><br /></span> participate
              internationally
            </h5>
            <VueSlickCarousel v-bind="WinTestimonialsSettings" class="px-2">
              <div
                v-for="(ircStory, ircStoryKey) in homeData.irc_stories"
                :key="ircStoryKey"
                class="px-2 pl-md-4 win-testimonial-inner"
                style="border-radius: 10px !important;"
              >
                <Testimonials
                  :type="'win_testimonial'"
                  :user_name="ircStory.user_name"
                  :user_age="ircStory.rating"
                  :win_text="ircStory.text"
                  :media="ircStory.media"
                />
              </div>
              <!--<Testimonials :type="'win_testimonial'" :user_name="'test'" :user_age="'2'" :win_text="'“I got to travel to Dubai and participate in IRC. It was fun!”'" :media="'https://images.avishkaar.cc/campaigns/robotility/robotility_ad_banner_v2.png'"/>
                  <Testimonials :type="'win_testimonial'" :user_name="'test'" :user_age="'2'" :win_text="'“I got to travel to Dubai and participate in IRC. It was fun!”'" :media="'https://images.avishkaar.cc/campaigns/robotility/robotility_ad_banner_v2.png'"/>
                  <Testimonials :type="'win_testimonial'" :user_name="'test'" :user_age="'2'" :win_text="'“I got to travel to Dubai and participate in IRC. It was fun!”'" :media="'https://images.avishkaar.cc/campaigns/robotility/robotility_ad_banner_v2.png'"/>
                  <Testimonials :type="'win_testimonial'" :user_name="'test'" :user_age="'2'" :win_text="'“I got to travel to Dubai and participate in IRC. It was fun!”'" :media="'https://images.avishkaar.cc/campaigns/robotility/robotility_ad_banner_v2.png'"/>-->
            </VueSlickCarousel>
          </div>
        </div>
      </div>

      <div class="pb-5 awards">
        <h2 class="pt-5 pb-1">Awards</h2>
        <VueSlickCarousel v-bind="awardSettings">
          <div class="px-md-3 px-1">
            <b-img-lazy
              v-bind="mainProps"
              class="col-10"
              :src="'https://images.avishkaar.cc/workflow/hp_v1/dia_award.png'"
              alt="Image 1"
            ></b-img-lazy>
          </div>
          <div class="px-md-3 px-1">
            <b-img-lazy
              v-bind="mainProps"
              class="col-10"
              :src="'https://images.avishkaar.cc/workflow/hp_v1/electronics_maker_award.png'"
              alt="Image 1"
            ></b-img-lazy>
          </div>
          <div class="px-md-3 px-1">
            <b-img-lazy
              v-bind="mainProps"
              class="col-10"
              :src="'https://images.avishkaar.cc/workflow/hp_v1/nasscom_award.png'"
              alt="Image 1"
            ></b-img-lazy>
          </div>
          <div class="px-md-3 px-1">
            <b-img-lazy
              v-bind="mainProps"
              class="col-10"
              :src="'https://images.avishkaar.cc/workflow/hp_v1/cii_design_excellence_award.png'"
              alt="Image 1"
            ></b-img-lazy>
          </div>
          <div class="px-md-3 px-1">
            <b-img-lazy
              v-bind="mainProps"
              class="col-10"
              :src="'https://images.avishkaar.cc/workflow/hp_v1/nasscom_award.png'"
              alt="Image 1"
            ></b-img-lazy>
          </div>
        </VueSlickCarousel>
      </div>
      <div>
        <h2 class="pt-5 pb-1">Media Presence</h2>
        <div class="px-md-5 px-0 mediaPresense" v-if="homeData.media">
          <VueSlickCarousel v-bind="mediaSettings" class="px-2">
            <div
              v-for="(mediaSlider, mediaKey) in homeData.media"
              :key="mediaKey"
              class="px-2"
            >
              <CarouselCard
                :type="'mediaPresense'"
                :category="mediaSlider.type"
                :text="mediaSlider.media_name"
                :thumbnail="mediaSlider.media_thumbnail_link"
                :media="mediaSlider.media_link"
                :url="mediaSlider.url"
              />
              <!-- add :title="mediaSlider.title" to display text on image -->
            </div>
          </VueSlickCarousel>
        </div>
      </div>

      <!-- Meet the team section -->
      <section class="meet-team mt-5">
        <div class="container">
          <div>
            <div>
              <h1>
                Meet the Team of Disruptors
              </h1>
            </div>
            <div class="meet-subtext mb-3">who are nurturing the Avishkaar army of innovators</div>
          </div>
          <div class="w-100">
            <VueSlickCarousel v-bind="meetTeamCarouselSettings">
              <MeetTeamCard :key="idx" v-for="(data, idx) in meetTeamCarouselData" :name="data.name" :position="data.position" :image="data.image" :isOrange="data.isOrange" :body="data.body" :description="data.description" />
              <!-- <MeetTeamCard :key="idx" v-for="(data, idx) in meetTeamCarouselData" :name="data.name" :position="data.position" :image="data.image" :isOrange="data.isOrange" :body="data.body" /> -->
            </VueSlickCarousel>
          </div>
        </div>
      </section>

      <div class="py-5 Curriculum">
        <div class="col-md-8 col-12 mx-auto pb-4">
          <h2 class="mb-1 pt-5 pb-1 text-md-center">
            Curriculum & Kits Designed by
          </h2>
          <h2
            class="mb-1 text-white px-2 mx-lg-auto text-center"
            style="background: #f36f2e; width: fit-content"
          >
            Alumni & Veterans of Prestigious
          </h2>
          <h2
            class="mb-1 text-white px-2 mx-lg-auto"
            style="background: #f36f2e; width: fit-content"
          >
            Universities & Companies
          </h2>
        </div>
        <VueSlickCarousel v-bind="awardSettings" class="col-md-8 mx-auto">
          <div class="">
            <b-img-lazy
              v-bind="mainProps"
              :src="'https://images.avishkaar.cc/workflow/vue/hp/adobe_logo.png'"
              alt="Image 1"
            ></b-img-lazy>
          </div>
          <div class="">
            <b-img-lazy
              v-bind="mainProps"
              :src="'https://images.avishkaar.cc/workflow/vue/hp/iitd_logo.png'"
              alt="Image 1"
            ></b-img-lazy>
          </div>
          <div class="">
            <b-img-lazy
              v-bind="mainProps"
              :src="'https://images.avishkaar.cc/workflow/vue/hp/bits_logo.png'"
              alt="Image 1"
            ></b-img-lazy>
          </div>
          <div class="">
            <b-img-lazy
              v-bind="mainProps"
              :src="'https://images.avishkaar.cc/workflow/vue/hp/insead_logo.png'"
              alt="Image 1"
            ></b-img-lazy>
          </div>
          <div class="">
            <b-img-lazy
              v-bind="mainProps"
              :src="'https://images.avishkaar.cc/workflow/vue/hp/ms_logo.png'"
              alt="Image 1"
            ></b-img-lazy>
          </div>
          <div class="">
            <b-img-lazy
              v-bind="mainProps"
              :src="'https://images.avishkaar.cc/workflow/vue/hp/uw_logo.png'"
              alt="Image 1"
            ></b-img-lazy>
          </div>
          <div class="">
            <b-img-lazy
              v-bind="mainProps"
              :src="'https://images.avishkaar.cc/workflow/vue/hp/vt_logo.png'"
              alt="Image 1"
            ></b-img-lazy>
          </div>
        </VueSlickCarousel>
      </div>
    </section>
    <Footer />
    <div class="finderModal">
      <b-modal
        id="finderModal"
        ref="my-modal"
        hide-footer
        size="lg"
        @hide="finderModalClose"
      >
        <template #modal-title class="w-100">
          <div class="d-flex flex-wrap col-12">
            <div
              class="col-md-3 col-12 my-auto pb-md-0 pb-0 pl-md-2 px-0"
              style="
                color: #606060;
                font-size: 18px;
                font-weight: 300 !important;
              "
            >
              Product Finder
            </div>
            <div class="d-md-flex d-none col-9">
              <div
                style="height: 11.5px; background: #ebebeb; border-radius: 7px"
                class="ml-md-3 mr-md-3 col-md-5 col-6 p-0 my-auto"
              >
                <div
                  class="h-100"
                  :style="
                    'background:' +
                    finderProgressBG +
                    ';width:' +
                    finderProgress +
                    '%;border-radius: 7px'
                  "
                ></div>
              </div>
              <div
                class="col-5 my-auto"
                style="font-size: 16px; font-weight: 300"
                :style="'color:' + finderProgressBG"
              >
                {{ finderStep }}
              </div>
            </div>
          </div>
        </template>
        <div class="d-block text-center pt-4">
          <div class="d-md-none d-flex justify-content-center px-4 pb-1">
            <div
              style="height: 11.5px; background: #ebebeb; border-radius: 7px"
              class="col-md-4 col-6 p-0 my-auto"
            >
              <div
                class="h-100"
                :style="
                  'background:' +
                  finderProgressBG +
                  ';width:' +
                  finderProgress +
                  '%;border-radius: 7px'
                "
              ></div>
            </div>
            <div
              class="col-md-3 col-5 my-auto"
              style="font-size: 16px; font-weight: 300"
              :style="'color:' + finderProgressBG"
            >
              <strong>
                {{ finderStep }}
              </strong>
            </div>
          </div>
          <div v-if="question_level_1_active" class="custom_radio_box">
            <div class="px-4 recom_ques_inner">
              <h6 class="col-12 pt-3">
                Q.{{ finderQuestionNum }} {{ recQuesOne.question }}
              </h6>
              <div class="d-flex flex-wrap text-left">
                <div
                  class="col-md-6 col-12 mt-4"
                  :key="AnsKey"
                  v-for="(Ans, AnsKey) in recQuesOne.answers"
                >
                  <input
                    type="radio"
                    name="ques1"
                    :id="AnsKey"
                    :value="AnsKey"
                    v-model="selectedAns.q1"
                  />
                  <label :for="AnsKey" class="col-12 h-100">{{ Ans }}</label>
                </div>
              </div>
            </div>
            <div
              class="text-right py-3 finder-btn"
              style="box-shadow: 0px -2px 2px rgba(0, 0, 0, 0.12)"
            >
              <div class="mx-4">
                <button
                  class="ab-btn-border px-5 mr-4"
                  @click="finderModalClose"
                >
                  Close
                </button>
                <button
                  :disabled="!selectedAns.q1"
                  v-bind:class="{ custom_disbale: !selectedAns.q1 }"
                  class="ab-btn px-5"
                  @click="
                    fetchResultQuesForAge(selectedAns.q1);
                    storingAnswerBase(selectedAns.q1, 'q1');
                  "
                >
                  Next
                </button>
              </div>
            </div>
          </div>
          <!--Ques no. 1-->
          <!--Ques no. 2-->
          <div v-if="question_level_2_active" class="custom_radio_box">
            <div class="px-4 recom_ques_inner">
              <h6 class="col-12" v-show="submitQuesOne">
                Q.{{ finderQuestionNum }}
                {{ recQuesbyOption.question_level_2.question }}
              </h6>
              <div class="d-flex flex-wrap text-left">
                <div
                  class="col-md-6 col-12 mt-4"
                  v-show="submitQuesOne"
                  :key="AnsKey"
                  v-for="(Ans, AnsKey) in recQuesbyOption.question_level_2
                    .answers"
                >
                  <input
                    type="radio"
                    name="ques2"
                    :id="AnsKey"
                    :value="AnsKey"
                    v-model="selectedAns.q2"
                  />
                  <label :for="AnsKey" class="col-12 h-100">{{ Ans }}</label>
                </div>
              </div>
            </div>
            <div
              class="text-right py-3 finder-btn"
              style="box-shadow: 0px -2px 2px rgba(0, 0, 0, 0.12)"
              v-show="submitQuesOne"
            >
              <div class="mx-4">
                <button
                  class="ab-btn-border px-5 mr-4"
                  @click="finderBack('q1')"
                >
                  Back
                </button>
                <button
                  class="ab-btn px-5"
                  :disabled="!selectedAns.q2"
                  v-bind:class="{ custom_disbale: !selectedAns.q2 }"
                  @click="
                    fetchQuesThree();
                    storingAnswerBase(selectedAns.q2, 'q2');
                  "
                >
                  Next
                </button>
              </div>
            </div>
          </div>
          <!--Ques no. 3-->
          <div v-if="question_level_3_active" class="custom_radio_box">
            <div class="px-4 recom_ques_inner">
              <h6 class="col-12" v-show="submitQuesTwo">
                Q.{{ finderQuestionNum }}
                {{ recQuesbyOption.question_level_3.question }}
              </h6>
              <div class="d-flex flex-wrap text-left">
                <div
                  v-show="submitQuesTwo"
                  class="col-md-6 col-12 mt-4"
                  :key="AnsKey"
                  v-for="(Ans, AnsKey) in recQuesbyOption.question_level_3
                    .answers"
                >
                  <input
                    type="radio"
                    name="ques3"
                    :id="AnsKey"
                    :value="AnsKey"
                    v-model="selectedAns.q3"
                  />
                  <label :for="AnsKey" class="col-12 h-100">{{ Ans }}</label>
                </div>
              </div>
            </div>
            <div
              class="text-right py-3 finder-btn"
              style="box-shadow: 0px -2px 2px rgba(0, 0, 0, 0.12)"
              v-show="submitQuesTwo"
            >
              <div class="mx-4">
                <button
                  class="ab-btn-border px-5 mr-4"
                  @click="finderBack('q2')"
                >
                  Back
                </button>
                <button
                  class="ab-btn px-5"
                  :disabled="!selectedAns.q3"
                  v-bind:class="{ custom_disbale: !selectedAns.q3 }"
                  @click="
                    fetchQuesFour();
                    storingAnswerBase(selectedAns.q3, 'q3');
                  "
                >
                  Next
                </button>
              </div>
            </div>
          </div>
          <!--Ques no. 4-->
          <div v-if="question_level_4_active" class="custom_radio_box">
            <div class="px-4 recom_ques_inner">
              <h6 class="col-12" v-show="submitQuesThree">
                Q.{{ finderQuestionNum }}
                {{ recQuesbyOption.question_level_4.question }}
              </h6>
              <div class="d-flex flex-wrap text-left">
                <div
                  v-show="submitQuesThree"
                  class="col-md-6 col-12 mt-4"
                  :key="AnsKey"
                  v-for="(Ans, AnsKey) in recQuesbyOption.question_level_4
                    .answers"
                >
                  <input
                    type="radio"
                    name="ques4"
                    :id="AnsKey"
                    :value="AnsKey"
                    v-model="selectedAns.q4"
                  />
                  <label :for="AnsKey" class="col-12 h-100">{{ Ans }}</label>
                </div>
              </div>
            </div>
            <div
              class="text-right py-3 finder-btn"
              style="box-shadow: 0px -2px 2px rgba(0, 0, 0, 0.12)"
              v-show="submitQuesThree"
            >
              <div class="mx-4">
                <button
                  class="ab-btn-border px-5 mr-4"
                  @click="finderBack('q3')"
                >
                  Back
                </button>
                <button
                  class="ab-btn px-5"
                  :disabled="!selectedAns.q4"
                  v-bind:class="{ custom_disbale: !selectedAns.q4 }"
                  @click="
                    storingAnswerBase(selectedAns.q4, 'q4');
                    fetchAnswerCode();
                  "
                >
                  Next
                </button>
              </div>
            </div>
          </div>
          <ShopCard
            class="my-4 mx-auto text-left"
            v-if="fetchRecProductCode.product_type == 'product'"
            v-show="RecProductCode"
            :productDetail="fetchRecProductCode"
            :Productfinder="true"
          />
          <CourseCard
            class="my-4 mx-auto text-left"
            v-if="fetchRecProductCode.product_type == 'course'"
            v-show="RecProductCode"
            :productDetail="fetchRecProductCode"
            :Productfinder="true"
          />
          <div
            class="text-right py-3 finder-btn"
            v-show="RecProductCode"
            style="box-shadow: 0px -2px 2px rgba(0, 0, 0, 0.12)"
          >
            <div class="mx-4">
              <span style="color: #606060" class="pr-know-more"
                >Want to know more?</span
              >
              <button
                class="ab-btn-border px-md-5 px-4 mx-md-4 mx-3"
                @click="showRequestCall('Request a Call!')"
              >
                Request a Call
              </button>
            </div>
          </div>
          <!-- <h6 class="col-12" v-if="fetchRecProductCode" v-show="RecProductCode">{{fetchRecProductCode.product_type}}</h6> -->
        </div>
      </b-modal>
      <b-modal id="youtubeModal" ref="youtubeModal" hide-footer hide-header>
        <button type="button" class="hp_modal_btn" @click="closeYtModal">
          <i class="fas fa-times"></i>
        </button>
        <div class="d-block text-center px-3 pt-3 pb-2">
          <iframe
            width="100%"
            height="315"
            :src="'https://www.youtube.com/embed/' + ytSource"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import CarouselCard from "@/components/microComponents/CarouselCard.vue";
import Testimonials from "@/components/microComponents/testimonialsCard.vue";
import MeetTeamCard from "@/components/MeetTeamCard";
import HomeProjectsSection from "@/components/HomeProjectsSection"

const RequestCall = () => import("@/components/requestCall");
const CourseCard = () => import("@/components/microComponents/courseCard");
const ShopCard = () => import("@/components/microComponents/shopCard");
// External Files
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  name: "Home",
  components: {
    Header,
    Footer,
    VueSlickCarousel,
    CarouselCard,
    Testimonials,
    RequestCall,
    CourseCard,
    ShopCard,
    MeetTeamCard,
    HomeProjectsSection,
  },
  data() {
    return {
      contentCarouselSettings: {
        arrows: true,
        dots: false,
        autoplay: true,
        centerMode: false,
        centerPadding: "0px",
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 576,
            settings: {
              arrows: false,
              dots: true,
            }
          }
        ],
      },
      meetTeamCarouselSettings: {
        "arrows": true,
        "dots": false,
        "focusOnSelect": true,
        "infinite": false,
        "speed": 500,
        "slidesToScroll": 1,
        "touchThreshold": 5,
        "responsive": [
          {
            "breakpoint": 1900,
            "settings": {
              "slidesToShow": 4,
              "slidesToScroll": 2,
              "infinite": true,
            }
          },
          {
            "breakpoint": 1024,
            "settings": {
              "slidesToShow": 3,
            }
          },
          {
            "breakpoint": 768,
            "settings": {
              "slidesToShow": 2,
            }
          },
          {
            "breakpoint": 420,
            "settings": {
              "arrows": false,
              "centerMode": true,
              "slidesToShow": 1,
              "centerPadding": "60px",
              "dots": true,
            }
          },
          {
            "breakpoint": 380,
            "settings": {
              "arrows": false,
              "centerMode": true,
              "slidesToShow": 1,
              "centerPadding": "40px",
              "dots": true,
            }
          }
        ]
      },
      meetTeamCarouselData: [
        {
          name: 'Tarun Bhalla',
          position: 'Founder & CEO',
          body: 'Tarun is a quintessential maker who strongly believes "Making is better than consuming". It\'s this belief that led him to start Avishkaar in India with the mission of creating an army of innovators.',
          description: `Tarun is a quintessential maker who strongly believes "Making is better than consuming". It's this belief that led him to start Avishkaar in India when no-one had heard the term of "Making" in the country. He has single-handedly created a market for Robotics, Tinkering and Making Products in India.  However, what keeps him most excited is his status as an engaged Father of two beautiful girls, a thoughtful Maker, a Vipassana Meditator and an avid traveler.`,
          image: 'https://images.avishkaar.cc/workflow/our-team/tarun_on_hover.webp',
          isOrange: true
        },
        {
          name: 'Pooja Goyal',
          position: 'Co-founder & COO',
          body: 'A serial entrepreneur who has built companies and led cross-functional teams across the globe, now heads operations, marketing, and sales at Avishkaar.',
          description: `A serial entrepreneur who has built companies and led cross-functional teams across the globe, now heads operations, marketing, and sales at Avishkaar. Her last venture, Intellitots Learning - an early year’s education company, was acquired by KLAY. Prior to that, she led the Acrobat Product marketing team at Adobe in the USA and later managed the Adobe Print and Scan business in India. An engineer from IIT Delhi, with an MBA from INSEAD, France, Pooja has worked in the USA, Europe, and India, and successfully paired her work experience at companies like Adobe Systems and Palm with her drive to change the education system. She is an angel investor and advisor to many startups and entrepreneurs. Pooja is a voracious reader, an avid traveler, and currently learning to play the piano.`,
          image: 'https://images.avishkaar.cc/workflow/our-team/pooja_goyal_1.webp',
          isOrange: false
        },
        {
          name: 'Rajeev Gaba',
          position: 'Co-founder & Product',
          body: 'Rajeev is the Product & Tech guy at Avishkaar. He is envisioning and making Avishkaar\'s patented and award-winning products.',
          description: `Rajeev is the Product & Tech guy at Avishkaar. He is envisioning and making Robotics products for Avishkaar. The Avishkaar Maker Studio, Tweak, Avishkaar Apps, the new Mechanical set of Avishkaar Robotics Design system - all of them came out of his team of Industrial Designers, Hardware, Firmware and Software Engineers. He is also the co-author of various patents in this domain along with Tarun.`,
          image: 'https://images.avishkaar.cc/workflow/our-team/rajeev-image.webp',
          isOrange: true
        },
        {
          name: 'Yogita Bhalla',
          position: 'Web, Design & Curriculum',
          body: 'Yogita is building deep intelligence about our customers and their wants here at Avishkaar to design our website and various apps, the curriculum, the videos, the packaging and the manuals are all created from her team.',
          description: `Yogita is building the deep intelligence about our customers and their wants here at Avishkaar. The beautiful and deeply functional website, the online curriculum arm, the UI and UX of various apps, the eye catching videos, the packaging and the manual designs are all created from her team of Web Designers, Videographers and Graphic Designers. She does all of this incredibly well because she trained at the best of these places - she was a Computer Scientist at Adobe in India, a Test Engineer at Microsoft in Seattle and a UI Designer at Cadence Design Systems in India before she launched her own startup - Simplylearnt that boasts of 2 million users.`,
          image: 'https://images.avishkaar.cc/workflow/our-team/yogita_mam_pic.webp',
          isOrange: false
        },
      ],
      get_web_path: process.env.VUE_APP_SITE_URL,
      answerOption: "",
      requestCallHead: null,
      selectedAns: {
        q1: "",
        q2: "",
        q3: "",
        q4: "",
      },
      selectedOptionTwo: "",
      selectedOptionThree: "",
      selectedOptionFour: "",
      submitQuesOne: false,
      submitQuesTwo: false,
      submitQuesThree: false,
      RecProductCode: false,
      q1: "",
      q2: "",
      q3: "",
      q4: "",
      question_level_1_active: true,
      question_level_2_active: false,
      question_level_3_active: false,
      question_level_4_active: false,
      finderStep: "4 Steps Away",
      finderProgress: 10,
      finderProgressBG: "#F36F2E",
      finderQuestionNum: 1,
      mainProps: {
        center: true,
        fluidGrow: true,
        blank: true,
        blankColor: "#bbb",
      },
      starSettings: {
        "lazyLoad": "ondemand",
        arrows: true,
        dots: false,
        centerMode: true,
        centerPadding: "3px",
        // focusOnSelect: true,
        infinite: true,
        slidesToShow: 4,
        speed: 500,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              centerMode: false,
              slidesToScroll: 1,
              initialSlide: 1,
              arrows: false,
              dots: true,
            },
          },
        ],
      },
      WinTestimonialsSettings: {
        "lazyLoad": "ondemand",
        arrows: true,
        dots: false,
        centerMode: true,
        centerPadding: "10px",
        focusOnSelect: true,
        infinite: true,
        slidesToShow: 3,
        speed: 500,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide: 1,
              arrows: false,
            },
          },
          {
            breakpoint: 500,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: "50px",
              dots: true,
              initialSlide: 1,
              slidesToScroll: 1,
              slidesToShow: 1,
            },
          },
        ],
      },
      TestimonialsSettings: {
        arrows: true,
        dots: false,
        centerMode: true,
        centerPadding: "10px",
        focusOnSelect: true,
        infinite: true,
        slidesToShow: 3,
        speed: 500,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 800,

            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
              arrows: false,
              dots: true,
            },
          },
        ],
      },
      TextTestimonialsSettings: {
        arrows: true,
        dots: false,
        centerMode: true,
        centerPadding: "0px",
        focusOnSelect: true,
        infinite: true,
        slidesToShow: 1,
        speed: 500,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
              arrows: false,
              dots: true,
            },
          },
        ],
      },
      awardSettings: {
        "lazyLoad": "ondemand",
        arrows: false, // arrows are invisible if set true
        dots: false,
        centerMode: true,
        centerPadding: "0px",
        focusOnSelect: true,
        infinite: true,
        slidesToShow: 4,
        speed: 100,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide: 1,
              arrows: false,
              dots: true,
            },
          },
        ],
      },
      skillsSettings: {
        lazyload: "ondemand",
        arrows: true,
        dots: false,
        centerMode: false,
        centerPadding: "10px",
        focusOnSelect: true,
        infinite: true,
        slidesToShow: 3,
        speed: 500,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
              // centerPadding: "180px",
            },
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
              arrows: false,
              centerMode: true,
              centerPadding: "130px",
            },
          },
          {
            breakpoint: 550,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
              arrows: false,
              centerMode: true,
              centerPadding: "45px",
            },
          },
          {
            breakpoint: 380,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
              centerMode: true,
              centerPadding: "25px",
            },
          },
        ],
      },
      mediaSettings: {
        "lazyLoad": "ondemand",
        arrows: true,
        dots: false,
        centerMode: true,
        centerPadding: "4px",
        focusOnSelect: true,
        infinite: true,
        slidesToShow: 3,
        speed: 500,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide: 1,
              arrows: false,
            },
          },
          {
            breakpoint: 500,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
            },
          },
        ],
      },
      skillsActiveTabColor: null,
      ytSource: null,
      fbUrl: false,
    };
  },
  computed: {
    ...mapGetters({
      homeData: "getHomeDetails",
      recQuesOne: "getRecEngineQuesOne",
      recQuesbyOption: "getRecEngineQuesByAge",
      fetchRecProductCode: "getAnswerCode",
    }),
  },
  methods: {
    ...mapActions([
      "fetchHomeDetails",
      "fetchRecEngineQuestionOne",
      "fetchRecEngineQuestionByAge",
      "fetchProductByRecEngineCode",
    ]),
    skillHeadBG(type) {
      this.skillsActiveTabColor = type;
    },
    showRequestCall(head) {
      this.requestCallHead = head;
      this.$root.$emit("bv::show::modal", "requestCallModal", "#btnShow");
    },
    test(test) {
      alert(test);
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    finderModalClose() {
      this.$refs["my-modal"].hide();
    },
    finderBack(ques) {
      switch (ques) {
        case "q1":
          this.question_level_1_active = true;
          this.question_level_2_active = false;
          this.finderStep = "4 Steps Away";
          this.finderProgress = 10;
          this.finderQuestionNum = this.finderQuestionNum - 1;
          break;
        case "q2":
          this.question_level_2_active = true;
          this.question_level_3_active = false;
          this.finderStep = "3 Steps Away";
          this.finderProgress = 25;
          this.finderQuestionNum = this.finderQuestionNum - 1;
          break;
        case "q3":
          this.question_level_3_active = true;
          this.question_level_4_active = false;
          this.finderStep = "2 Steps Away";
          this.finderProgress = 50;
          this.finderQuestionNum = this.finderQuestionNum - 1;
          break;
      }
    },
    fetchResultQuesForAge(val) {
      this.fetchRecEngineQuestionByAge(val);
      this.submitQuesOne = true;
      this.question_level_1_active = false;
      this.question_level_2_active = true;
      this.finderStep = "3 Steps Away";
      this.finderProgress = 25;
      this.finderQuestionNum = this.finderQuestionNum + 1;
    },
    fetchQuesThree() {
      this.submitQuesTwo = true;
      this.question_level_2_active = false;
      this.question_level_3_active = true;
      this.finderStep = "2 Steps Away";
      this.finderProgress = 50;
      this.finderQuestionNum = this.finderQuestionNum + 1;
    },
    fetchQuesFour() {
      this.submitQuesThree = true;
      this.question_level_3_active = false;
      this.question_level_4_active = true;
      this.finderStep = "1 Step Away";
      this.finderProgress = 75;
      this.finderQuestionNum = this.finderQuestionNum + 1;
    },
    storingAnswerBase(val, q) {
      switch (q) {
        case "q1":
          this.q1 = val;
          break;
        case "q2":
          this.q2 = val;
          break;
        case "q3":
          this.q3 = val;
          break;
        case "q4":
          this.q4 = val;
          break;
      }
      this.answerOption = this.q1 + this.q2 + this.q3 + this.q4;
    },
    fetchAnswerCode() {
      this.RecProductCode = true;
      this.finderStep = "Completed";
      this.finderProgressBG = "#9BC157";
      this.finderProgress = 100;
      this.question_level_4_active = false;
      if (this.answerOption.length == 4)
        this.fetchProductByRecEngineCode(this.answerOption);
    },
    openYtModal(src) {
      this.$refs["youtubeModal"].show();
      this.ytSource = src;
    },
    closeYtModal() {
      this.$refs["youtubeModal"].hide();
      this.ytSource = null;
    },
    homeCarouselClick(type, link) {
      if (type == 'video') this.openYtModal(link);
      // else this.$router.push(link);
      else window.location.href = link;
    },
    // fbRedirect(userType) {
    //   // console.log(userType, 'user-type');
    //   this.fbUrl = (
    //     (userType === 'parent' || userType === 'student') ? `https://www.facebook.com/groups/letsavishkaar` :
    //     userType === 'educator' ? `https://www.facebook.com/groups/avishkaarforeducation` :
    //     userType === false ? false :
    //     false
    //   )
    // }
  },
  created() {
    this.fetchHomeDetails();
    this.fetchRecEngineQuestionOne();
    document.title = "Avishkaar - Robotics and Coding for kids";
  },
  watch: {
    homeData: function (val) {
      if (val.carousel) {
        const i = new Image();
        i.src = this.homeData.carousel[0].mobile;
        const iDesk = new Image();
        iDesk.src = this.homeData.carousel[0].main;
      }
    },
  },
  mounted() {
    // check if the user is logged in
    if (this.$cookies.get("userAccess")) this.fbUrl = true;
    else this.fbUrl = false;

    console.log(this.homeData.dataBySkillCode, 'homeData');
  }
};
</script>
<style scoped>
body {
  background-color: #f5f5f5;
}
h2 {
  font-size: 30px;
}
.hero {
  background-color: rgb(225, 94, 43);
}
.hero .side-svg {
  position: absolute;
}
.sec_share {
  background: #003e65;
}
.sec_share .card {
  border-radius: 8px;
}

/* request a call section */
.req-call {
  height: 160px;
  background: #003E65;
  color: #fff;
  font-size: 24px;
  position: relative; /* to set calling svg absolute */
}
.req-call > .req-call-caller {
  position: absolute;
  bottom: 0;
  left: 20px;
  
  height: 118px;
}
.req-call > .d-flex {
  height: 100%;
  justify-content: space-evenly;
  align-items: center;
  position: relative;
  z-index: 1;
}
@media screen and (max-width: 768px) {
  .req-call {
    height: 224px;
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .req-call-caller {
    display: none;
  }
  .req-call > .d-flex {
    flex-direction: column;
  }
  .req-call >.d-flex > .ab-btn {
    width: 100%;
  }
}

/* meet-the-team section */
.meet-team {
  /* height: 100vh;
  min-height: 100vh; */
  background-color: #edf1f3;
}

.meet-team > .container {
  height: 110vh;
  min-height: 100vh;
  background-color: #edf1f3;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 576px) {
  .meet-team > .container > div > div > h1 {
    font-size: 24px;
  }
  .meet-team > .container > div > div.meet-subtext {
    font-size: 1.1rem;
  }
}

@media screen and (min-width: 576px) {
  .join-comm-head {
    margin: 0px 32px;
  }
}


</style>
<style>
/* style to home-banner dots */
/* referred from: https://stackoverflow.com/questions/38045776/how-to-reposition-the-dots-in-slick/38046004 */
.home-banner .slider {
  width: 650px;
  margin: 0 auto;
}
.home-banner .slick-dots{
  position: absolute;
  bottom: 20px;
  display: block;
  width: 100%;
  padding: 10;
  margin: 0;
  list-style: none;
  text-align: center;
}
.home-banner .slick-dots li.slick-active button:before{
  font-size:15px;
  color:blue;
}

/* style to home-banner dots */
/* referred from: https://stackoverflow.com/questions/64026198/how-to-change-style-color-of-arrows-in-vue-slick-carousel */
.home-banner button.slick-prev {
  left: 30px !important;
}

.home-banner button.slick-next {
  /* position: relative; */
  right: 30px !important;
}

/* .home-banner button.slick-next:before {
  right: 30px;
} */

/* ---- */

/* home banner v4 arrows style */

/* responsive arrows */
@media screen and (max-width: 576px) {
  .desktop-carousel .carousel-control-next {
    display: none;
  }
  .desktop-carousel .carousel-control-prev {
    display: none;
  }
}

/* responsive dots */
@media screen and (min-width: 577px) {
  .desktop-carousel .carousel-indicators {
    display: none;
  }
}

/* left */
/* .home-banner2 {
  position: relative;
}
.home-banner2::before {
  content: url("https://images.avishkaar.cc/banner_carousel/desktop/home_page_banner_desktop_(resize).webp") / "Banner Image";
  position: absolute;
  top: 0;
  left: 0;
  width: 100vh;
  height: 100%;
  min-height:333px;
  object-fit: contain;
} */
/* @media screen and (max-width: 576px) {
  .home-banner2::before {
    content: url("https://images.avishkaar.cc/banner_carousel/mobile/home_page_banner_mobile_(resize).webp") / "Banner Image Mobile";
  }
} */

/* .home-banner2 {
  position: relative;
  /* min-height: 348px; * /
  min-height: 333px;
}
@media screen and (max-width: 290px) {
  .home-banner2 {
    min-height: 266px;
  }
}
@media screen and (min-width: 291px) and (max-width: 330px) {
  .home-banner2 {
    min-height: 304px;
  }
}
@media screen and (min-width: 331px) and (max-width: 379px) {
  .home-banner2 {
    min-height: 357px;
  }
}
@media screen and (min-width: 380px) and (max-width: 576px) {
  .home-banner2 {
    min-height: 390px;
  }
}
@media screen and (min-width: 577px) and (max-width: 768px) {
  .home-banner2 {
    min-height: 202.5px;
  }
}
@media screen and (min-width: 769px) and (max-width: 1024px) {
  .home-banner2 {
    min-height: 270px;
  }
} */

.home-banner2 {
  position: relative;
}

.home-banner2 > .fallback-image {
  /* position: relative; */
  height: 100%;
  width: 100%;
  /* top: 0;
  left: 0; */
  /* z-index: -1; */
}

.home-banner2 .desktop-carousel {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;
}

.home-banner2 .desktop-carousel .carousel-control-prev  {
  height: 80px;
  width: 80px;
  height: 100%;
}
.home-banner2 .desktop-carousel .carousel-control-prev-icon {
  height: 80px;
  width: 80px;
  background-image: none;
}
.home-banner2 .desktop-carousel .carousel-control-prev-icon::before {
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  content: "\f053";
  font-size: 80px;
  color: #ddd;
}
.home-banner2 .desktop-carousel .carousel-control-prev:hover .carousel-control-prev-icon::before {
  color: #f36f2e;
}

/* right */
.home-banner2 .desktop-carousel .carousel-control-next  {
  height: 80px;
  width: 80px;
  height: 100%;
}
.home-banner2 .desktop-carousel .carousel-control-next-icon {
  height: 80px;
  width: 80px;
  background-image: none;
}
.home-banner2 .desktop-carousel .carousel-control-next-icon::before {
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  content: "\f054";
  font-size: 80px;
  color: #ddd;
}
.home-banner2 .desktop-carousel .carousel-control-next:hover .carousel-control-next-icon::before  {
  color: #f36f2e;
}

.home-banner2 .desktop-carousel .carousel-control-prev-icon {
  height: 80px;
  width: 80px;
}

/* ---- */

/* home banner v4 dots style */

/* .home-banner2 .carousel-indicators {
  background-color: #dcdcdc;
} */

.home-banner2 .carousel-indicators li {
  width: 10px;
  height: 10px;
  border-radius: 100px;
  border: 0 solid #000;
  -moz-border-radius: 100px;
  -webkit-border-radius: 100px;
  background-color: #dcdcdc;
  transition: width 0.5s;
}
.home-banner2 .carousel-indicators li * {
  border-radius: 100px;
  -moz-border-radius: 100px;
  -webkit-border-radius: 100px;
}
.home-banner2 .carousel-indicators li.active {
  background-color: #f36f2e;
  width: 20px;
  border-radius: 1000px;
  transition: width 0.5s;
  /* border-radius: 4px; */
}


/* border radius to carousel below dozens-of-students */
.win-testimonial-inner .overlay_img {
  border-radius: 10px !important;
}
/* ---- */


.innovate-carousel .slick-active .card-body {
  opacity: 1 !important;
}
.innovate-carousel .slick-slide {
  opacity: 1 !important;
}

.startStudent .slick-active {
  opacity: 1;
}

.content .slick-track {
  padding: 0 !important;
}
.content .slick-list {
  padding: 0 !important;
}
.content .slick-slide {
  padding: 0 !important;
}

.meet-team .slick-active {
  opacity: 1;
}

.dozen-student .slick-active {
  opacity: 1;
}


.home .slick-dots li {
  width: 10px !important;
  height: 10px !important;
  border-radius: 50% !important;
  background: #dcdcdc !important;

  opacity: 1 !important;
  display: inline-block;
  margin: 0 3px;
  cursor: pointer;
  transition: opacity 0.4s ease-in-out,
    width 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.home .slick-dots li.slick-active {
  width: 22px !important;
  border-radius: 10px !important;
  background: #f36f2e !important;
  opacity: 1;
}
.home .slick-dots li button:before {
  content: "";
}
.home button.slick-prev:hover::before,
.home button.slick-next:hover::before {
  color: #f36f2e !important;
}
.slick-list {
  padding: 30px 10px 15px 10px !important;
}
.slick-slide {
  padding: 10px;
}
.awards .slick-list {
  height: 20vh;
}
.Curriculum .slick-list {
  height: 24vh;
}
.home .startStudent button.slick-prev:before,
.home .startStudent button.slick-next:before {
  color: rgba(255, 255, 255, 0.5);
}
.home .mediaPresense button.slick-prev:before,
.home .mediaPresense button.slick-next:before {
  color: rgba(0, 0, 0, 0.12);
}
.home .startStudent .card {
  border-radius: 16px;
}
.home .slick-prev:before {
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  content: "\f053";
}
.home .slick-next:before {
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  content: "\f054";
}
.home .slick-arrow {
  transform: scale(3.5) !important;
}
.home .skills_card .card-header-tabs {
  background: #003e65;
  width: fit-content;
  margin: auto;
  /* padding: 15px 40px; */
}
.home .skills_card .nav-item:first-child a {
  border-radius: 51px 0px 0px 51px;
  padding-left: 50px;
}
.home .skills_card .subTabIcon {
  padding: 20px 0px;
  width: 110px;
}
.home .skills_card .nav-link:not(.active) .subTabIcon {
  background: #003e65 !important;
}
.join .nav-link:not(.active) img {
  filter: grayscale(1.8);
  transition: filter 0.4s ease-in-out;
}
.join .nav-link img {
  width: 74px;
  height: 96px;
}

/* .home .skills_card .nav-item:nth-child(2) .nav-link.active,
.skillYellow {
background: #E99514;
}

.home .skills_card .nav-item:first-child .nav-link.active,
.skillGreen {
  background: #8FBD3B;

}
.home .skills_card .nav-item:nth-child(3) .nav-link.active,
.skillOrange {
background: #00B3D5;
}
.home .skills_card .nav-item:nth-child(4) .nav-link.active,
.skillBlue {
background: #F36F2E;
} */
.home .skills_card .nav-item:last-child a {
  border-radius: 0px 51px 51px 0px;
  padding-right: 50px;
}
.home .skills_card .nav-item a {
  padding: 0px;
  background: #003e65;
  border-radius: 0;
  border: none;
}
.home .skills_card .nav-tabs {
  border: none;
  position: absolute;
  display: flex;
  justify-content: center;
  width: 100%;
  z-index: 1;
  top: -56px;
}
.home .skills_card .card {
  border: none;
}
.win_sec .win_inner {
  background: #9bc157;
}
.join .nav-tabs {
  background: #003e65;
  border-radius: 12px;
  width: 60%;
  margin: auto;
  position: absolute;
  left: 0;
  right: 0;
  top: -25%;
}
.join .nav-link:hover {
  border-bottom: 3px solid #fcac31 !important;
  border-left: none !important;
  border-right: none !important;
  border-top: none !important;
}
.join .nav-link {
  border-bottom: 3px solid transparent !important;
  border-left: none !important;
  border-right: none !important;
  border-top: none !important;
  margin: 0px 15px;
}
.join .nav-link.active {
  border-bottom: 3px solid #fcac31 !important;
  background: transparent !important;
  border-left: none !important;
  border-right: none !important;
  border-top: none !important;
}
.join-head {
  background: #f8f8f8;
}
.skill_image {
  width: 40px;
  height: 40px;
}

@media screen and (max-width: 576px) {
  .hear-carousel-block {
    padding-left: 20px;
    padding-right: 20px;
  }
}
@media screen and (min-width: 576px) {
  .hear-carousel-block{
    width: 50%;
    margin-top: 30px;
  }
}

.svg_user {
  bottom:0;
  right: 0;
  /* margin: 0; */
}
@media screen and (max-width: 576px) {
  .svg_user > svg {
    width: 119px;
    height: 112px;
  }
}


@media only screen and (max-width: 780px) {
  .recom_ques_inner {
    height: auto !important;
  }
  .Curriculum h2 {
    font-size: 20px;
    text-align: left !important;
  }
  .home .skills_card .subTabIcon {
    padding: 20px 0px;
    width: 90px;
  }
  .skill_image {
    width: 30px;
    height: 30px;
  }
  .book_text {
    font-weight: bold;
  }
  .home .nav-item {
    padding: 0px !important;
  }
  .home .skills_card .nav-item a {
    padding: 0px 10px;
  }
  .home .skills_card .nav-item a svg {
    width: 60%;
  }
  .join .nav-tabs {
    width: auto;
    position: relative;
  }
  .join-head {
    background: #fff;
  }
  .join-head .card {
    border: none;
    box-shadow: none;
  }
  .sec_share h3 {
    font-size: 20px !important;
  }
}
@media only screen and (max-width: 430px) {
  /* .svg_user {
    right: 0px !important;
  } */
  h2 {
    font-size: 22px !important;
  }
  #finderModal .modal-dialog {
    margin: 0;
    height: 100vh;
  }
  #finderModal .modal-content {
    height: 100%;
  }
  #finderModal .finder-btn {
    box-shadow: rgb(0 0 0 / 12%) 0px -2px 2px;
    position: absolute;
    bottom: 0;
    width: 100%;
    justify-content: center;
    text-align: center !important;
  }

  .pr-know-more {
    font-size: 13px;
  }
  .awards .slick-list {
    height: 13vh !important;
  }
  .Curriculum .slick-list {
    height: 17vh !important;
  }
  .home .skills_card .subTabIcon {
    padding: 20px 0px;
    width: 85px;
  }
  .home .skills_card .subTabIcon p {
    font-size: 10px;
  }
  .home .skills_card .nav-item:last-child a,
  .home .skills_card .nav-item:first-child a {
    padding: 0px 0px;
    overflow: hidden;
  }
  .home .skills_card .nav-item a {
    padding: 0px;
  }
  .join .nav-tabs .nav-link {
    margin: 0 30px !important;
    padding: 0 !important;
  }
  .join .nav-link p {
    margin-top: 10px;
    font-size: 12px;
  }
  .join .nav-link img {
    width: 50px;
    height: 70px;
  }
}
.modal-title {
  width: 100% !important;
  margin: 0;
}
.modal-body {
  padding: 0 !important;
}
</style>
<style  scoped>
.custom_radio_box input[type="radio"] {
  visibility: hidden;
  position: absolute;
}
.custom_radio_box input[type="radio"] + label {
  cursor: pointer;
  width: 100%;
  margin: auto;
  display: flex;
  align-items: center;
}
.custom_radio_box input[type="radio"]:checked + label {
  background: #fff3d8;
  width: 100%;
  border: 1px solid #f36f2e !important;
}
.custom_radio_box input[type="radio"] + label:before {
  content: "";
  top: 37%;
  left: 20px;
  width: 18px;
  height: 18px;
  position: absolute;
  border-radius: 100%;
  transition: all 0.3s ease;
  background-color: white i !important;
  box-shadow: inset 0 0 0 18px #e0e0e0;
}
.custom_radio_box input[type="radio"]:checked + label:before {
  border: 1px solid #f36f2e;
  box-shadow: inset 0 0 0 4px #fff;
  background: #f36f2e;
}
.custom_radio_box label {
  padding: 20px 60px;
  cursor: pointer;
  border: 1px solid #909090;
  box-sizing: border-box;
  border-radius: 8px;
  font-weight: 400;
}
.custom_radio_box h6 {
  color: #303030;
  font-weight: 600;
  font-size: 18px;
  text-align: left;
}
.hp_modal_btn {
  border: none;
  position: absolute;
  z-index: 2;
  background: #d2691e;
  padding: 0;
  top: -15px;
  right: -15px;
  border-radius: 50%;
  height: 30px;
  width: 30px;
}
.recom_ques_inner {
  height: 40vh;
  overflow: scroll;
}
.recom_ques_inner::-webkit-scrollbar {
  width: 1px !important;
  height: 1px;
  background: transparent;
}
.recom_ques_inner::-webkit-scrollbar {
  border-radius: 10px;
  background-color: transparent;
}
@media only screen and (max-width: 780px) {
  .Curriculum h2 {
    font-size: 18px !important;
  }
}

.hp_testimonial {
  border-radius: 10px !important;
  background: transparent;
  cursor: pointer;
}
.hp_testimonial .card-body {
  overflow: hidden;
  padding: 0px;
  background: #ffffff;
  border-radius: 10px;
}
</style>